/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { T } from "./Translate";
import useInfiniteScroll from "../hooks/useInfiniteScroll";
import {
  Container,
  Avatar,
  Typography,
  Tabs,
  Tab,
  Box,
  CircularProgress,
  List,
  ListItem,
  Button,
  CardMedia,
  Grid,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  IconButton,
  TextField,
  InputAdornment,
  Paper,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack,
  useMediaQuery,
  Alert,
} from "@mui/material";
import { useParams, useNavigate, Link as RouterLink } from "react-router-dom";
import { ThumbUpAlt as ThumbUpAltIcon } from "../icons";
import { Search as SearchIcon } from "../icons";
import { MoreVert as MoreVertIcon } from "../icons";
import { isLoggedIn } from "../session";
import PropTypes from "prop-types";
import { auth, db } from "../firebase";
import {
  doc,
  getDoc,
  onSnapshot,
  collection,
  query,
  orderBy,
  where,
  limit,
  getDocs,
  setDoc,
  deleteField,
  updateDoc,
  deleteDoc,
  increment,
  serverTimestamp,
  getCountFromServer,
} from "firebase/firestore";
import ProfileHeader from "./ProfileHeader";
import BottomToolbar from "./BottomToolbar";
import CopyToClipboardComponent from "./CopyToClipboardButton";
import OfferBuyButton from "../components/OfferBuyButton";
import { ArrowBackIos as ArrowBackIosIcon } from "../icons";
import { ArrowForwardIos as ArrowForwardIosIcon } from "../icons";
import { Storefront as StorefrontIcon } from "../icons";
import { Language as LanguageIcon } from "../icons";
import Chip from "@mui/material/Chip";
import { Bookmark as BookmarkIcon } from "../icons";
import { BookmarkBorder as BookmarkBorderIcon } from "../icons";
import { Lock as LockIcon } from "../icons";
import AvatarGroup from "@mui/material/AvatarGroup";
import { ExpandMore as ExpandMoreIcon } from "../icons";
import { ExpandLess as ExpandLessIcon } from "../icons";
import { ForumOutlined as ForumOutlinedIcon } from "../icons";
import { Send as SendIcon } from "../icons";
import { Chat as ChatIcon } from "../icons";
import { Close as CloseIcon } from "../icons";
import { blockUser, unblockUser, fetchBlockedIds } from "../utils/blockedUsers";
import { canMessageUser } from "../utils/messaging";
import {
  fetchQuestionsAndAnswers,
  postQuestion,
  postAnswer,
  fetchAnswers,
  fetchUserLikes,
  handleMeSirve,
  fetchQuestionsAndAnswersWithUserData,
  toggleSaveOffer,
  fetchSavedOfferIds,
  fetchVerifiedUids,
  fetchOfficialUids,
  reportItem,
  unfollowCompany,
  formatCount,
} from "./homeUtils";
import {
  getHorarioLabel,
  toggleSaveEvent,
  fetchSavedEventIds,
  handleMeInteresaEvent,
  recordTicketSale,
  markEventCommissionPaid,
  getPendingEventCommission,
  fetchUserEventLikes,
  postEventQuestion,
  postEventAnswer,
  fetchEventQuestionsAndAnswersWithUserData,
  getEventDates,
  formatEventDatesList,
  sellsTicketsWithPaypal,
} from "./eventsUtils";
import EventCountdown from "../components/EventCountdown";
import { brandColors, barColors } from "../theme";
import { alpha } from "@mui/material/styles";
import InterestButton from "../components/InterestButton";
import DiscountPriceBreakdown from "../components/DiscountPriceBreakdown";
import OfferPaymentBadges from "../components/OfferPaymentBadges";
import VerifiedBadge from "./VerifiedBadge";
import EditThreadDialog from "../components/EditThreadDialog";
import { feedPostSx, feedPostHeaderSx, feedPostMediaRadius, feedPostTextPx } from "../pageLayout";
import OfficialBadge from "./OfficialBadge";
import useAuthorPhotos from "./useAuthorPhotos";
import PaypalButton from "../components/PaypalButton";
import { safeHttpUrl, normalizeWebsite, websiteLabel } from "../utils/safeUrl";

import SearchClearAdornment from "../components/SearchClearAdornment";
import MessagesClosedDialog from "../components/MessagesClosedDialog";
import FollowListDialog from "../components/FollowListDialog";
const CONDITION_STYLES = {
  Nuevo: { color: "#4a90e2", bgcolor: "rgba(74,144,226,0.16)", label: <T>Nuevo</T> },
  Usado: { color: "#50e3c2", bgcolor: "rgba(80,227,194,0.16)", label: <T>Usado</T> },
  Reparar: { color: "#ed8936", bgcolor: "rgba(237,137,54,0.16)", label: <T>Para reparar</T> },
};

const CATEGORY_STYLES = {
  alojamiento: { color: "#4a90e2", bgcolor: "rgba(74,144,226,0.16)", label: <T>Alojamiento</T> },
  compra: { color: "#50e3c2", bgcolor: "rgba(80,227,194,0.16)", label: <T>Compra</T> },
  alquiler: { color: "#ed8936", bgcolor: "rgba(237,137,54,0.16)", label: <T>Alquiler</T> },
};

// Carga con getDocs las publicaciones de una pestaña del perfil (autos,
// propiedades, hilos), recién cuando la pestaña se abrió por primera vez.
function useTabFetch({ profileUid, visited, buildQuery, setItems, onDone }) {
  useEffect(() => {
    if (!profileUid || !visited) return undefined;
    let cancelled = false;
    getDocs(buildQuery())
      .then((snap) => {
        if (!cancelled) setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch((e) => console.error("Error cargando pestaña del perfil:", e))
      .finally(() => {
        if (!cancelled) onDone();
      });
    return () => {
      cancelled = true;
    };
    // buildQuery/setItems/onDone cambian de identidad en cada render; la carga
    // depende solo del perfil y de si la pestaña ya se abrió.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileUid, visited]);
}

// Mantiene una suscripción (p. ej. onSnapshot de preguntas/respuestas) por
// cada id visible: suscribe los que aparecen, cancela los que dejan de estar
// visibles (búsqueda) y todos al desmontar. Antes se re-suscribía cada
// publicación del perfil cada vez que cambiaba la lista y nunca se cancelaba,
// así que los listeners se acumulaban.
function useVisibleSubscriptions(ids, subscribe) {
  const subscriptionsRef = useRef(new Map());
  const subscribeRef = useRef(subscribe);
  subscribeRef.current = subscribe;
  const idsKey = ids.join(",");

  useEffect(() => {
    const wanted = new Set(idsKey ? idsKey.split(",") : []);
    const subscriptions = subscriptionsRef.current;
    subscriptions.forEach((unsubscribe, id) => {
      if (!wanted.has(id)) {
        unsubscribe?.();
        subscriptions.delete(id);
      }
    });
    wanted.forEach((id) => {
      if (!subscriptions.has(id)) subscriptions.set(id, subscribeRef.current(id));
    });
  }, [idsKey]);

  useEffect(() => {
    const subscriptions = subscriptionsRef.current;
    return () => {
      subscriptions.forEach((unsubscribe) => unsubscribe?.());
      subscriptions.clear();
    };
  }, []);
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      style={{
        display: value === index ? "flex" : "none",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      {value === index && (
        <Box sx={{ p: 3, flexGrow: 1, minWidth: 0, overflow: "auto" }}>{children}</Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const ProfilePage = () => {
  const [messagesClosedOpen, setMessagesClosedOpen] = useState(false);
  // Pestaña abierta del popup de seguidos/seguidores (null = cerrado).
  const [followListTab, setFollowListTab] = useState(null);
  let navigate = useNavigate();
  const { uid: profileUid } = useParams();
  const [value, setValue] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [offers, setOffers] = useState([]);
  const [events, setEvents] = useState([]);
  const [stores, setStores] = useState([]);
  const [cars, setCars] = useState([]);
  const [places, setPlaces] = useState([]);
  const [profileThreads, setProfileThreads] = useState([]);
  // Cada pestaña descarga sus publicaciones recién la primera vez que se abre
  // (antes el perfil bajaba ofertas, eventos, hilos, autos y propiedades de
  // entrada y tardaba mucho en cargar). visitedTabs: pestañas ya abiertas;
  // loadedTabs: las que ya terminaron de cargar (para mostrar un spinner y no
  // "No hay resultados" mientras llegan).
  const [visitedTabs, setVisitedTabs] = useState(["ofertas"]);
  const [loadedTabs, setLoadedTabs] = useState([]);
  const markTabLoaded = (key) =>
    setLoadedTabs((prev) => (prev.includes(key) ? prev : [...prev, key]));
  // Para mostrar las pestañas "Autos"/"Propiedades" alcanza con saber si hay
  // al menos una publicación (query con limit(1)), sin descargarlas todas.
  const [hasCars, setHasCars] = useState(false);
  const [hasPlaces, setHasPlaces] = useState(false);
  // Total de publicaciones del perfil (cabecera, como Instagram); null = cargando.
  const [postsCount, setPostsCount] = useState(null);
  const [blockedIds, setBlockedIds] = useState([]);
  const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState(null);
  const [following, setFollowing] = useState([]);
  const [followingDetails, setFollowingDetails] = useState([]);
  const [followingCount, setFollowingCount] = useState(0);
  const [followersCount, setFollowersCount] = useState(0);
  const [userAuthenticated, setUserAuthenticated] = useState(false);
  const [userLikes, setUserLikes] = useState({});
  const [eventUserLikes, setEventUserLikes] = useState({});
  const [openImageModal, setOpenImageModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalImages, setModalImages] = useState([]);
  const [questions, setQuestions] = useState({});
  const [newQuestion, setNewQuestion] = useState({});
  const [newAnswer, setNewAnswer] = useState({});
  const answerInputRef = useRef({});
  // Ofertas/eventos con un toggle de "Me Interesa" en curso (ver mismo
  // criterio en home.js/events.js): evita disparar handleMeSirve/
  // handleMeInteresaEvent dos veces con un doble click/tap.
  const pendingLikeOfferIds = useRef(new Set());
  const pendingLikeEventIds = useRef(new Set());
  const [answers, setAnswers] = useState({});
  const [showMoreQuestions, setShowMoreQuestions] = useState({});
  const [questionsAndAnswers, setQuestionsAndAnswers] = useState([]);
  const [aspectRatio, setAspectRatio] = useState("9:16"); // Valor predeterminado

  const [savedOfferIds, setSavedOfferIds] = useState([]);
  const [verifiedUids, setVerifiedUids] = useState([]);
  const [officialUids, setOfficialUids] = useState([]);
  const authorPhotos = useAuthorPhotos([profileUid]);
  const [showQA, setShowQA] = useState({});
  // Menú ⋮ de las publicaciones (ver handleOpenPostMenu).
  const [postMenu, setPostMenu] = useState(null);
  const [editingThread, setEditingThread] = useState(null);
  const isWideHeader = useMediaQuery("(min-width:600px)");

  const [savedEventIds, setSavedEventIds] = useState([]);
  const [purchasingEventId, setPurchasingEventId] = useState(null);
  const [pendingEventCommissions, setPendingEventCommissions] = useState({});
  const [commissionFeedback, setCommissionFeedback] = useState({});
  const [openAttendeesDialog, setOpenAttendeesDialog] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [isLoadingAttendees, setIsLoadingAttendees] = useState(false);
  const [attendeeUserProfiles, setAttendeeUserProfiles] = useState({});
  const [eventQuestionsAndAnswers, setEventQuestionsAndAnswers] = useState({});
  const [newEventQuestion, setNewEventQuestion] = useState({});
  const [newEventAnswer, setNewEventAnswer] = useState({});
  const [showMoreEventQuestions, setShowMoreEventQuestions] = useState({});
  const [showEventQA, setShowEventQA] = useState({});

  const handleLoadedMetadata = (e) => {
    const video = e.target;
    const ratio = video.videoWidth / video.videoHeight;
    setAspectRatio(ratio > 1 ? "16:9" : "9:16"); // Detecta si es 16:9 o 9:16
  };

  const handleOpenImageModal = (images, startIndex = 0) => {
    setModalImages(images);
    setCurrentImageIndex(startIndex);
    setOpenImageModal(true);
  };

  const handleCloseImageModal = () => {
    setOpenImageModal(false);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === modalImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePreviousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? modalImages.length - 1 : prevIndex - 1
    );
  };

  // Navegación por teclado del slideshow (← → para cambiar de imagen, Esc
  // para cerrar). El modal ya cierra con click afuera (Dialog onClose), esto
  // solo agrega el control de teclado que un lightbox espera tener.
  useEffect(() => {
    if (!openImageModal) return;
    const onKeyDown = (e) => {
      if (e.key === "ArrowRight") {
        setCurrentImageIndex((i) => (modalImages.length ? (i + 1) % modalImages.length : 0));
      } else if (e.key === "ArrowLeft") {
        setCurrentImageIndex((i) =>
          modalImages.length ? (i - 1 + modalImages.length) % modalImages.length : 0
        );
      } else if (e.key === "Escape") {
        setOpenImageModal(false);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [openImageModal, modalImages.length]);

  // Swipe táctil del slideshow: umbral de 40px para no confundir un tap con
  // un swipe. Sin esto, en mobile la única forma de cambiar de imagen eran
  // las flechas, poco natural para un lightbox de fotos.
  const touchStartXRef = useRef(null);
  const handleModalTouchStart = (e) => {
    touchStartXRef.current = e.touches[0].clientX;
  };
  const handleModalTouchEnd = (e) => {
    if (touchStartXRef.current === null) return;
    const deltaX = e.changedTouches[0].clientX - touchStartXRef.current;
    touchStartXRef.current = null;
    if (Math.abs(deltaX) < 40 || modalImages.length < 2) return;
    if (deltaX < 0) {
      setCurrentImageIndex((i) => (i + 1) % modalImages.length);
    } else {
      setCurrentImageIndex((i) => (i - 1 + modalImages.length) % modalImages.length);
    }
  };

  // Fetch stores for this profile
  useEffect(() => {
    if (!profileUid) return;
    const fetchStores = async () => {
      try {
        const q = query(collection(db, "stores"), where("ownerId", "==", profileUid));
        const snap = await getDocs(q);
        setStores(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error("Error fetching stores:", e);
      }
    };
    fetchStores();
  }, [profileUid]);

  // Al pasar a otro perfil se vuelve a la pestaña Ofertas y se olvida qué
  // pestañas estaban cargadas (eran del perfil anterior).
  useEffect(() => {
    setValue(0);
    setVisitedTabs(["ofertas"]);
    setLoadedTabs([]);
    setHasCars(false);
    setHasPlaces(false);
    setPostsCount(null);
    setEvents([]);
    setCars([]);
    setPlaces([]);
    setProfileThreads([]);
  }, [profileUid]);

  const eventsTabVisited = visitedTabs.includes("eventos");
  const threadsTabVisited = visitedTabs.includes("hilos");
  const carsTabVisited = visitedTabs.includes("autos");
  const placesTabVisited = visitedTabs.includes("propiedades");

  // Conteo de publicaciones (ofertas, eventos, hilos propios sin
  // republicaciones, autos y propiedades) con consultas de conteo, sin bajar
  // los documentos. De paso define si se muestran las pestañas "Autos" y
  // "Propiedades" (solo si el perfil tiene al menos una de ese tipo).
  // Eventos: en un perfil ajeno solo los públicos (ver la consulta de la
  // pestaña Eventos: las reglas no dejan contar privados ajenos).
  useEffect(() => {
    if (!profileUid) return;
    let cancelled = false;
    const isOwn = auth.currentUser?.uid === profileUid;
    const countOf = async (collectionName, ...extraFilters) => {
      try {
        const q = query(collection(db, collectionName), where("uid", "==", profileUid), ...extraFilters);
        return (await getCountFromServer(q)).data().count;
      } catch (e) {
        console.error(`Error contando ${collectionName}:`, e);
        return 0;
      }
    };
    Promise.all([
      countOf("offers"),
      countOf("events", ...(isOwn ? [] : [where("isPrivate", "==", false)])),
      countOf("threads", where("repostOf", "==", null)),
      countOf("cars"),
      countOf("places"),
    ]).then(([offersN, eventsN, threadsN, carsN, placesN]) => {
      if (cancelled) return;
      setHasCars(carsN > 0);
      setHasPlaces(placesN > 0);
      setPostsCount(offersN + eventsN + threadsN + carsN + placesN);
    });
    return () => {
      cancelled = true;
    };
  }, [profileUid]);

  useTabFetch({
    profileUid,
    visited: carsTabVisited,
    buildQuery: () => query(collection(db, "cars"), where("uid", "==", profileUid)),
    setItems: setCars,
    onDone: () => markTabLoaded("autos"),
  });
  useTabFetch({
    profileUid,
    visited: placesTabVisited,
    buildQuery: () => query(collection(db, "places"), where("uid", "==", profileUid)),
    setItems: setPlaces,
    onDone: () => markTabLoaded("propiedades"),
  });
  // Hilos publicados por este perfil (ver Hilos.js), incluye sus republicaciones.
  useTabFetch({
    profileUid,
    visited: threadsTabVisited,
    buildQuery: () =>
      query(collection(db, "threads"), where("uid", "==", profileUid), orderBy("createdAt", "desc")),
    setItems: setProfileThreads,
    onDone: () => markTabLoaded("hilos"),
  });

  useEffect(() => {
    if (!profileUid) return;
    const fetchFollowCounts = async () => {
      try {
        const [followingSnap, followersSnap] = await Promise.all([
          getDoc(doc(db, "userFollowing", profileUid)),
          getDoc(doc(db, "companyFollowers", profileUid)),
        ]);
        setFollowingCount(followingSnap.exists() ? Object.keys(followingSnap.data()).length : 0);
        setFollowersCount(followersSnap.exists() ? Object.keys(followersSnap.data()).length : 0);
      } catch (e) {
        console.error("Error fetching follow counts:", e);
      }
    };
    fetchFollowCounts();
  }, [profileUid]);

  // Se usa onAuthStateChanged en vez de isLoggedIn()/auth.currentUser
  // directo: tras un reload (F5, o el pull-to-refresh que llama a
  // window.location.reload() en App.js), Firebase Auth todavía no terminó
  // de restaurar la sesión persistida en el momento en que este efecto
  // corre, así que auth.currentUser da null un instante aunque el usuario
  // sí esté logueado. Eso hacía que fetchProfile nunca se disparara con el
  // uid correcto y que verifiedUids/savedOfferIds quedaran vacíos para
  // siempre (ver efecto de fetchVerifiedUids más abajo).
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      if (!firebaseUser) {
        navigate("/login");
        return;
      }
      setUserAuthenticated(true);
      fetchBlockedIds(firebaseUser.uid).then(setBlockedIds);

      const fetchProfile = async () => {
        try {
          const docRef = doc(db, "users", profileUid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            setProfile(docSnap.data());
          }
        } catch (error) {
          console.error("Error al obtener el perfil:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchProfile();
    });

    return () => unsubscribe();
  }, [navigate, profileUid]);

  const handleQuestionSubmit = async (offerId) => {
    const questionText = newQuestion[offerId]?.trim();
    if (questionText) {
      await postQuestion(offerId, auth.currentUser?.uid, questionText);
      setNewQuestion((prev) => ({ ...prev, [offerId]: "" }));
    }
  };

  const handleAnswerSubmit = async (questionId, offerId) => {
    if (
      newAnswer[questionId]?.trim() !== "" &&
      !answers[offerId]?.some((answer) => answer.questionId === questionId)
    ) {
      await postAnswer(
        questionId,
        auth.currentUser?.uid,
        newAnswer[questionId],
        offerId
      );
      setNewAnswer((prevAnswers) => ({ ...prevAnswers, [questionId]: "" }));
    }
  };

  useEffect(() => {
    // Itera sobre las respuestas para cada oferta
    Object.entries(answers).forEach(([offerId, offerAnswers]) => {
      // Itera sobre las preguntas para la oferta actual
      questions[offerId]?.forEach((question) => {
        // Verifica si la pregunta ya tiene una respuesta
        const hasAnswer = offerAnswers.some(
          (answer) => answer.questionId === question.id
        );

        // Si la pregunta ya tiene una respuesta, limpia el estado de la nueva respuesta
        if (hasAnswer) {
          setNewAnswer((prevAnswers) => ({
            ...prevAnswers,
            [question.id]: "",
          }));
        }
      });
    });
  }, [answers, questions]);

  // Solo las ofertas de este perfil. (Antes además se escuchaba la colección
  // completa de ofertas con fetchOffersAndStats, que pisaba esta lista y en
  // mobile hacía que el perfil tardara muchísimo en cargar.)
  useEffect(() => {
    if (!profileUid) return;
    setLoading(true);
    const q = query(
      collection(db, "offers"),
      where("uid", "==", profileUid),
      orderBy("createdAt", "desc")
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
          const offersData = snapshot.docs.map((doc) => {
            const data = doc.data(); // Access the document data
            let imageUrls = [];
            if (data.images && Array.isArray(data.images)) {
              imageUrls = data.images;
            } else if (data.images && typeof data.images === "string") {
              imageUrls = [data.images];
            }

            return {
              id: doc.id,
              ...data, // Spread the document data
              imageUrls,
            };
          });
          setLoading(false);
          setOffers(offersData);
      },
      (error) => {
        console.error("Error al obtener ofertas:", error);
        setLoading(false);
      }
    );
    return () => unsubscribe();
  }, [profileUid]);

  // Eventos: recién cuando se abre la pestaña (ver visitedTabs).
  useEffect(() => {
    if (!profileUid || !eventsTabVisited) return;
    // En un perfil ajeno solo se listan los públicos: las reglas no dejan
    // listar privados ajenos, y una consulta que pudiera incluirlos falla
    // entera. En el propio perfil se ven todos.
    const isOwn = auth.currentUser?.uid === profileUid;
    const q = query(
      collection(db, "events"),
      where("uid", "==", profileUid),
      ...(isOwn ? [] : [where("isPrivate", "==", false)]),
      orderBy("createdAt", "desc")
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
          markTabLoaded("eventos");
          const eventsData = snapshot.docs.map((doc) => {
            const data = doc.data();
            return {
              ...data,
              id: doc.id,
              name: data.name,
              title: data.title,
              description: data.description,
              eventType: data.eventType,
              date: data.date,
              createdAt: data.createdAt,
            };
          });
          setEvents(eventsData);
      },
      (error) => {
        console.error("Error al obtener eventos:", error);
        markTabLoaded("eventos");
      }
    );
    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileUid, eventsTabVisited]);

  useEffect(() => {
    const fetchFollowingDetails = async () => {
      try {
        const isAuthenticated = await isLoggedIn();
        if (isAuthenticated) {
          const { uid } = auth.currentUser || {};
          if (uid) {
            const userFollowingRef = doc(db, "userFollowing", uid);
            const userFollowingDoc = await getDoc(userFollowingRef);

            if (userFollowingDoc.exists()) {
              const followingData = userFollowingDoc.data();
              const followingIds = Object.keys(followingData);

              const followedCompaniesDetails = await Promise.all(
                followingIds.map(async (companyId) => {
                  const companyDoc = await getDoc(doc(db, "users", companyId));
                  if (companyDoc.exists()) {
                    return { id: companyId, ...companyDoc.data() };
                  }
                  return null;
                })
              );

              setFollowingDetails(followedCompaniesDetails.filter(Boolean));
            } else {
              setFollowingDetails([]);
            }
          }
        }
      } catch (error) {
        console.error("Error al obtener detalles de empresas seguidas:", error);
      }
    };

    fetchFollowingDetails();
  }, [following]);

  useEffect(() => {
    const fetchFollowing = async () => {
      try {
        const isAuthenticated = await isLoggedIn();
        if (isAuthenticated) {
          const { uid } = auth.currentUser || {};
          if (uid) {
            const userFollowingRef = doc(db, "userFollowing", uid);
            const userFollowingDoc = await getDoc(userFollowingRef);

            if (userFollowingDoc.exists()) {
              const followingData = userFollowingDoc.data();
              const followingIds = Object.keys(followingData);
              setFollowing(followingIds);
            } else {
              setFollowing([]);
            }
          }
        }
        setLoading(false);
      } catch (error) {
        console.error("Error al obtener las empresas seguidas:", error);
        setLoading(false);
      }
    };

    fetchFollowing();
  }, []);

  const handleFollow = async (companyId) => {
    try {
      const isAuthenticated = await isLoggedIn();
      if (isAuthenticated) {
        const { uid } = auth.currentUser || {};
        if (uid) {
          setLoading(true);
          const userFollowingRef = doc(db, "userFollowing", uid);
          const companyFollowersRef = doc(db, "companyFollowers", companyId);

          const isFollowing = following.includes(companyId);

          if (isFollowing) {
            // Dejar de seguir
            await updateDoc(userFollowingRef, {
              [companyId]: deleteField(),
            });
            await updateDoc(companyFollowersRef, {
              [uid]: deleteField(),
            });
            setFollowing(following.filter((id) => id !== companyId));
          } else {
            // Comenzar a seguir
            await setDoc(
              userFollowingRef,
              { [companyId]: true },
              { merge: true }
            );
            await setDoc(companyFollowersRef, { [uid]: true }, { merge: true });
            setFollowing([...following, companyId]);
          }
          setLoading(false);
        }
      } else {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error al manejar el seguimiento de la empresa:", error);
      setLoading(false);
    }
  };

  const isCompanyFollowed = (companyId) => following.includes(companyId);

  // Seguir/dejar de seguir desde el popup de seguidos/seguidores: mantiene al
  // día el botón Seguir del perfil y los contadores de la cabecera.
  const handleFollowListChange = (targetUid, result) => {
    const delta = result === "followed" ? 1 : result === "unfollowed" ? -1 : 0;
    if (!delta) return;
    setFollowing((prev) => (delta > 0 ? [...prev, targetUid] : prev.filter((id) => id !== targetUid)));
    if (profileUid === auth.currentUser?.uid) setFollowingCount((n) => Math.max(0, n + delta));
    if (targetUid === profileUid) setFollowersCount((n) => Math.max(0, n + delta));
  };

  // --- Header de tarjeta de Ofertas (paridad con home.js) ---
  const handleToggleSaveClick = (offerData) => {
    if (!offerData || !auth.currentUser) return;
    const isSaved = savedOfferIds.includes(offerData.id);
    toggleSaveOffer(auth.currentUser.uid, offerData.id, isSaved);
    setSavedOfferIds((prev) =>
      isSaved ? prev.filter((id) => id !== offerData.id) : [...prev, offerData.id]
    );
  };

  // --- Menú ⋮ de las publicaciones del perfil (todas las secciones) ---
  // postMenu: { anchorEl, item, kind: "offers" | "events" | "threads" | "cars" | "places" }.
  const POST_KINDS = {
    offers: { detail: "/offers", edit: "/editOffers", reportType: "offer" },
    events: { detail: "/events", edit: "/editEvents", reportType: "event" },
    threads: { detail: "/hilos", edit: null, reportType: "thread" },
    cars: { detail: "/cars", edit: "/editCars", reportType: "car" },
    places: { detail: "/trips", edit: "/editTrips", reportType: "place" },
  };
  const myUid = auth.currentUser?.uid;

  const handleOpenPostMenu = (event, item, kind) => {
    event.stopPropagation();
    setPostMenu({ anchorEl: event.currentTarget, item, kind });
  };

  const handlePostMenuClose = () => setPostMenu(null);

  // El autor "real" del contenido: en una republicación de un hilo, quien
  // escribió el original (no quien lo republicó).
  const postAuthorUid = ({ item, kind }) =>
    kind === "threads" && item.repostOf ? item.originalUid : item.uid;

  const postPath = ({ item, kind }) =>
    `${POST_KINDS[kind].detail}/${kind === "threads" ? item.repostOf || item.id : item.id}`;

  const postTitle = ({ item, kind }) =>
    kind === "threads"
      ? (item.repostOf ? item.originalText : item.text) || ""
      : item.product || item.title || "";

  const handleCopyPostLink = (menu) => {
    navigator.clipboard?.writeText(`${window.location.origin}${postPath(menu)}`).catch(() => {});
  };

  const handleSharePost = (menu) => {
    if (navigator.share) {
      navigator.share({
        title: postTitle(menu).slice(0, 100),
        text: menu.kind === "threads" ? undefined : menu.item.description,
        url: `${window.location.origin}${postPath(menu)}`,
      }).catch(() => {});
    } else {
      handleCopyPostLink(menu);
    }
  };

  const handleEditPost = ({ item, kind }) => {
    if (kind === "threads") setEditingThread(item);
    else navigate(`${POST_KINDS[kind].edit}?edit=${item.id}`);
  };

  const handleReportPost = (menu) => {
    if (!myUid) return;
    reportItem({
      reporterId: myUid,
      targetType: POST_KINDS[menu.kind].reportType,
      targetId: menu.item.id,
      companyId: postAuthorUid(menu),
    });
  };

  const handleToggleBlockPostAuthor = async (menu) => {
    const targetUid = postAuthorUid(menu);
    if (!myUid || !targetUid) return;
    if (blockedIds.includes(targetUid)) {
      await unblockUser(myUid, targetUid);
      setBlockedIds((prev) => prev.filter((id) => id !== targetUid));
    } else {
      await blockUser(myUid, targetUid);
      setBlockedIds((prev) => (prev.includes(targetUid) ? prev : [...prev, targetUid]));
    }
  };

  // --- Header de tarjeta de Eventos (paridad con events.js) ---
  const handleToggleSaveEventClick = (eventData) => {
    if (!eventData || !auth.currentUser) return;
    const isSaved = savedEventIds.includes(eventData.id);
    toggleSaveEvent(auth.currentUser.uid, eventData.id, isSaved);
    setSavedEventIds((prev) =>
      isSaved ? prev.filter((id) => id !== eventData.id) : [...prev, eventData.id]
    );
  };

  const handleAttendEvent = async (eventId) => {
    await handleAttend(eventId);
  };

  const handleOpenAttendeesDialog = async (eventId) => {
    setSelectedEventId(eventId);
    setOpenAttendeesDialog(true);
    setIsLoadingAttendees(true);
    const attendeeIds = attendees[eventId] || [];
    if (attendeeIds.length > 0) {
      const profiles = { ...attendeeUserProfiles };
      const newAttendeeIds = attendeeIds.filter((id) => !profiles[id]);
      await Promise.all(
        newAttendeeIds.map(async (attendeeId) => {
          const userDocRef = doc(db, "users", attendeeId);
          const userDocSnap = await getDoc(userDocRef);
          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            profiles[attendeeId] = {
              id: attendeeId,
              name: userData.name || userData.displayName || "Usuario",
              profileImageUrl: userData.profileImageUrl || "",
            };
          }
        })
      );
      setAttendeeUserProfiles(profiles);
    }
    setIsLoadingAttendees(false);
  };

  const handleCloseAttendeesDialog = () => {
    setOpenAttendeesDialog(false);
    setSelectedEventId(null);
  };

  const handleAttendeeClick = (attendeeId) => {
    navigate(`/profile/${attendeeId}`);
    handleCloseAttendeesDialog();
  };

  const handleTicketPurchaseApproved = async (eventData, details) => {
    try {
      await recordTicketSale({
        eventId: eventData.id,
        sellerId: eventData.uid,
        buyerId: auth.currentUser.uid,
        buyerEmail: details.payer?.email_address,
        amount: eventData.ticketPrice,
        paypalTransactionId: details.id,
      });
      setPurchasingEventId(null);
    } catch (error) {
      console.error("Error al registrar la compra de la entrada:", error);
    }
  };

  const handleEventQuestionSubmit = async (eventId) => {
    const questionText = newEventQuestion[eventId]?.trim();
    if (questionText && auth.currentUser) {
      await postEventQuestion(eventId, auth.currentUser.uid, questionText);
      setNewEventQuestion((prev) => ({ ...prev, [eventId]: "" }));
    }
  };

  const handleEventAnswerSubmit = async (questionId, eventId) => {
    const answerText = newEventAnswer[questionId]?.trim();
    if (answerText && auth.currentUser) {
      await postEventAnswer(questionId, auth.currentUser.uid, answerText, eventId);
      setNewEventAnswer((prev) => ({ ...prev, [questionId]: "" }));
    }
  };

  const handleEventCommissionApproved = async (eventData, details) => {
    const amount = pendingEventCommissions[eventData.id]?.amount || 0;
    await markEventCommissionPaid({
      eventId: eventData.id,
      sellerId: auth.currentUser.uid,
      amount,
      paypalTransactionId: details.id,
    });
    setCommissionFeedback((prev) => ({
      ...prev,
      [eventData.id]: { type: "success", message: "Comisión pagada correctamente." },
    }));
    const result = await getPendingEventCommission(eventData.id, auth.currentUser.uid);
    setPendingEventCommissions((prev) => ({ ...prev, [eventData.id]: result }));
  };

  const [deleteTarget, setDeleteTarget] = useState(null);

  const requestDelete = (collectionName, id) =>
    setDeleteTarget({ collectionName, id });

  const cancelDelete = () => setDeleteTarget(null);

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    const { collectionName, id } = deleteTarget;
    try {
      // Si es una republicación, hay que descontarle el contador al hilo
      // original (ver mismo criterio en Hilos.js/handleDeleteThread).
      if (collectionName === "threads") {
        const repostOf = profileThreads.find((t) => t.id === id)?.repostOf;
        if (repostOf) {
          await updateDoc(doc(db, "threads", repostOf), { repostsCount: increment(-1) });
        }
      }
      await deleteDoc(doc(db, collectionName, id));
      if (collectionName === "offers") {
        setOffers((prev) => prev.filter((item) => item.id !== id));
      } else if (collectionName === "events") {
        setEvents((prev) => prev.filter((item) => item.id !== id));
      } else if (collectionName === "cars") {
        setCars((prev) => prev.filter((item) => item.id !== id));
      } else if (collectionName === "places") {
        setPlaces((prev) => prev.filter((item) => item.id !== id));
      } else if (collectionName === "threads") {
        setProfileThreads((prev) => prev.filter((item) => item.id !== id));
      }
    } catch (error) {
      console.error("Error al eliminar la publicación:", error);
    } finally {
      setDeleteTarget(null);
    }
  };

  const isBlocked = blockedIds.includes(profileUid);
  const isOwnProfile = profileUid === auth.currentUser?.uid;
  // "Perfil público" (ajustes de privacidad): si está desactivado, la
  // promesa del toggle es "solo vos podés ver tu perfil" — mismo criterio
  // que ya usa UserMap.js para el popup de otros usuarios en el mapa.
  const isPrivateForViewer = profile?.perfilPublico === false && !isOwnProfile;
  const canSeeFollowCounts = isOwnProfile || profile?.mostrarSeguidores !== false;

  const handleBlockUser = async () => {
    if (!auth.currentUser || !profileUid) return;
    await blockUser(auth.currentUser.uid, profileUid);
    setBlockedIds((prev) => (prev.includes(profileUid) ? prev : [...prev, profileUid]));
  };

  const handleUnblockUser = async () => {
    if (!auth.currentUser || !profileUid) return;
    await unblockUser(auth.currentUser.uid, profileUid);
    setBlockedIds((prev) => prev.filter((id) => id !== profileUid));
  };

  // Mismo esquema que handleStartDirectChat en members.js: conversationId
  // determinístico (ordenando los dos uids) para que ambos lados terminen
  // usando el mismo doc en vez de crear conversaciones duplicadas.
  const handleStartDirectChat = async () => {
    if (!auth.currentUser || !profileUid) {
      navigate("/login");
      return;
    }
    if (!(await canMessageUser(profileUid, auth.currentUser.uid))) {
      setMessagesClosedOpen(true);
      return;
    }
    try {
      const currentUserId = auth.currentUser.uid;
      const sorted = [currentUserId, profileUid].sort();
      const conversationId = `directo_${sorted[0]}_${sorted[1]}`;
      const convRef = doc(db, "conversations", conversationId);
      const snap = await getDoc(convRef);

      if (!snap.exists()) {
        await setDoc(convRef, {
          type: "directo",
          participants: sorted,
          createdAt: serverTimestamp(),
          lastMessageTime: serverTimestamp(),
          unreadCount: { [currentUserId]: 0, [profileUid]: 0 },
        });
      }
      navigate(`/chatbox/directo/${profileUid}`);
    } catch (error) {
      console.error("Error al iniciar el chat:", error);
    }
  };

  const handleMeSirveClick = async (offerId) => {
    if (pendingLikeOfferIds.current.has(offerId)) return;
    pendingLikeOfferIds.current.add(offerId);
    try {
      await handleMeSirve(
        offerId,
        userAuthenticated,
        auth.currentUser?.uid,
        setOffers,
        setUserLikes
      );
    } finally {
      pendingLikeOfferIds.current.delete(offerId);
    }
  };

  const handleMeInteresaClick = async (eventId) => {
    if (pendingLikeEventIds.current.has(eventId)) return;
    pendingLikeEventIds.current.add(eventId);
    try {
      await handleMeInteresaEvent(eventId, !!auth.currentUser, auth.currentUser?.uid, setEventUserLikes);
    } finally {
      pendingLikeEventIds.current.delete(eventId);
    }
  };

  useEffect(() => {
    if (userAuthenticated) {
      fetchUserLikes(userAuthenticated, setUserLikes);
      fetchUserEventLikes(userAuthenticated, setEventUserLikes);
    }
  }, [userAuthenticated]);

  useEffect(() => {
    if (userAuthenticated && auth.currentUser) {
      fetchSavedOfferIds(auth.currentUser.uid).then(setSavedOfferIds);
      fetchVerifiedUids().then(setVerifiedUids);
      fetchOfficialUids().then(setOfficialUids);
      fetchSavedEventIds(auth.currentUser.uid).then(setSavedEventIds);
    } else {
      setSavedOfferIds([]);
      setVerifiedUids([]);
      setOfficialUids([]);
      setSavedEventIds([]);
    }
  }, [userAuthenticated]);

  // Comisión pendiente de los propios eventos pagos de este perfil (ver
  // EVENT_COMMISSION_RATE en eventsUtils.js).
  useEffect(() => {
    if (!auth.currentUser || profileUid !== auth.currentUser.uid) return;
    const ownPaidEvents = events.filter((event) => event.isPaid);
    ownPaidEvents.forEach(async (event) => {
      const result = await getPendingEventCommission(event.id, auth.currentUser.uid);
      setPendingEventCommissions((prev) => ({ ...prev, [event.id]: result }));
    });
  }, [events, profileUid]);

  const getDomainFromUrl = (url) => {
    // Si la URL no es válida, devuelve la URL original
    if (!url) {
      return url;
    }

    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = "http://" + url;
    }
    const domain = new URL(url).hostname;

    // Encuentra el punto "." antes de la extensión
    const dotIndex = domain.lastIndexOf(".");

    // Si no se encuentra un punto, devuelve el dominio completo
    if (dotIndex === -1) {
      return domain;
    }

    // Extrae el dominio hasta el punto "."
    const shortenedDomain = domain.substring(0, dotIndex);

    // Si el dominio es demasiado largo, lo recorta y agrega "..."
    if (shortenedDomain.length > 15) {
      return shortenedDomain.slice(0, 15) + "...";
    }

    // Devuelve el dominio recortado
    return shortenedDomain;
  };

  const formatDate = (date) => {
    if (date instanceof Date) {
      return date.toLocaleDateString();
    } else if (date && date.toDate instanceof Function) {
      return date.toDate().toLocaleDateString();
    }
    return "";
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // "Autos"/"Propiedades" solo se muestran si el perfil tiene publicaciones
  // de ese tipo, así que el índice de cada Tab/TabPanel depende de qué haya
  // publicado.
  const visibleTabKeys = [
    "ofertas",
    "eventos",
    "tiendas",
    "hilos",
    ...(hasCars ? ["autos"] : []),
    ...(hasPlaces ? ["propiedades"] : []),
  ];
  const tabIndex = (key) => visibleTabKeys.indexOf(key);
  const currentTabKey = visibleTabKeys[value];

  // La pestaña abierta dispara su carga (ver visitedTabs).
  useEffect(() => {
    if (!currentTabKey) return;
    setVisitedTabs((prev) => (prev.includes(currentTabKey) ? prev : [...prev, currentTabKey]));
  }, [currentTabKey]);

  // Spinner mientras llega la primera carga de una pestaña (en vez de
  // mostrar "No hay resultados").
  const tabLoadingSpinner = (
    <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
      <CircularProgress size={28} />
    </Box>
  );

  const matchesSearch = (text) =>
    text.toLowerCase().includes(searchTerm.trim().toLowerCase());

  // Ofertas, eventos, autos y propiedades se muestran de a 10 y se suman
  // más al hacer scroll; la búsqueda o cambiar de perfil vuelve a la primera tanda.
  const PROFILE_PAGE_SIZE = 10;
  const scrollResetKey = `${profileUid}|${searchTerm}`;
  const filteredOffers = offers.filter((offerData) =>
    matchesSearch(`${offerData.product || ""} ${offerData.description || ""}`)
  );
  const filteredEvents = events.filter((eventData) =>
    matchesSearch(`${eventData.title || ""} ${eventData.description || ""}`)
  );
  const filteredCars = cars.filter((car) =>
    matchesSearch(`${car.title || ""} ${car.marca || ""} ${car.modelo || ""}`)
  );
  const filteredPlaces = places.filter((place) =>
    matchesSearch(`${place.title || ""} ${place.place || ""} ${place.city || ""}`)
  );
  const { limit: offersLimit, sentinelRef: offersSentinelRef } = useInfiniteScroll(scrollResetKey, PROFILE_PAGE_SIZE);
  const { limit: eventsLimit, sentinelRef: eventsSentinelRef } = useInfiniteScroll(scrollResetKey, PROFILE_PAGE_SIZE);
  const { limit: carsLimit, sentinelRef: carsSentinelRef } = useInfiniteScroll(scrollResetKey, PROFILE_PAGE_SIZE);
  const { limit: placesLimit, sentinelRef: placesSentinelRef } = useInfiniteScroll(scrollResetKey, PROFILE_PAGE_SIZE);

  // Los asistentes ya vienen en cada evento del onSnapshot (antes se volvía a
  // leer cada evento con getDoc y después, de a uno, el perfil de cada
  // asistente de todos los eventos).
  const attendees = Object.fromEntries(events.map((event) => [event.id, event.attendees || []]));
  const [attendeeProfiles, setAttendeeProfiles] = useState({});
  const requestedAttendeeIds = useRef(new Set());

  // Solo las publicaciones visibles (la tanda actual del scroll infinito)
  // cargan preguntas/respuestas y avatares de asistentes.
  const visibleOfferIds = filteredOffers.slice(0, offersLimit).map((o) => o.id);
  const visibleEvents = filteredEvents.slice(0, eventsLimit);
  const visibleEventIds = visibleEvents.map((e) => e.id);

  useVisibleSubscriptions(visibleOfferIds, (offerId) => {
    const unsubscribeQuestions = fetchQuestionsAndAnswers(offerId, (fetchedQuestions) =>
      setQuestions((prev) => ({ ...prev, [offerId]: fetchedQuestions }))
    );
    const unsubscribeAnswers = fetchAnswers(offerId, (fetchedAnswers) =>
      setAnswers((prev) => ({ ...prev, [offerId]: fetchedAnswers }))
    );
    const unsubscribeWithUserData = fetchQuestionsAndAnswersWithUserData(offerId, (fetchedData) =>
      setQuestionsAndAnswers((prev) => ({ ...prev, [offerId]: fetchedData }))
    );
    return () => {
      unsubscribeQuestions();
      unsubscribeAnswers();
      unsubscribeWithUserData();
    };
  });

  useVisibleSubscriptions(visibleEventIds, (eventId) =>
    fetchEventQuestionsAndAnswersWithUserData(eventId, (fetchedData) =>
      setEventQuestionsAndAnswers((prev) => ({ ...prev, [eventId]: fetchedData }))
    )
  );

  // Avatares de los primeros 3 asistentes de cada evento visible (los que se
  // muestran en la tarjeta; el diálogo de asistentes carga el resto aparte).
  const visibleAttendeeKey = visibleEvents
    .flatMap((event) => (event.attendees || []).slice(0, 3))
    .join(",");
  useEffect(() => {
    const idsToFetch = visibleAttendeeKey
      .split(",")
      .filter((id) => id && !requestedAttendeeIds.current.has(id));
    if (idsToFetch.length === 0) return;
    idsToFetch.forEach((id) => requestedAttendeeIds.current.add(id));
    Promise.all(
      idsToFetch.map(async (attendeeId) => {
        try {
          const userDocSnap = await getDoc(doc(db, "users", attendeeId));
          return userDocSnap.exists()
            ? [attendeeId, { profileImageUrl: userDocSnap.data().profileImageUrl || "" }]
            : null;
        } catch {
          return null;
        }
      })
    ).then((entries) => {
      const fetched = Object.fromEntries(entries.filter(Boolean));
      setAttendeeProfiles((prev) => ({ ...prev, ...fetched }));
    });
  }, [visibleAttendeeKey]);

  const handleAttend = async (eventId) => {
    try {
      const user = auth.currentUser;
      if (user) {
        const eventDocRef = doc(db, "events", eventId);
        const eventDocSnap = await getDoc(eventDocRef);

        if (eventDocSnap.exists()) {
          const eventData = eventDocSnap.data();
          const attendees = eventData.attendees || [];

          if (attendees.includes(user.uid)) {
            const updatedAttendees = attendees.filter(
              (attendeeId) => attendeeId !== user.uid
            );
            await updateDoc(eventDocRef, { attendees: updatedAttendees });
          } else {
            const updatedAttendees = [...attendees, user.uid];
            await updateDoc(eventDocRef, { attendees: updatedAttendees });
          }
        }
      } else {
        navigate("/login");
      }
    } catch (error) {
      console.error("Error al manejar la asistencia al evento:", error);
    }
  };

  if (loading) {
    return (
      <Container sx={{ mt: 8, mb: 10, maxWidth: { xs: "100%", md: "980px" } }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 4 }}>
          <Skeleton variant="circular" width={120} height={120} sx={{ mr: 2 }} />
          <Box>
            <Skeleton variant="text" width={200} height={40} />
            <Skeleton variant="text" width={150} height={24} />
          </Box>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 2, mb: 1 }} />
          <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 2, mb: 1 }} />
          <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 2 }} />
        </Box>
        <Box sx={{ display: "flex", gap: 2, mb: 4 }}>
          <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 2 }} />
        </Box>
        {[1, 2].map((i) => (
          <Box key={i} sx={{ mb: 2 }}>
            <Skeleton variant="rectangular" width="100%" height={120} sx={{ borderRadius: 2, mb: 1 }} />
          </Box>
        ))}
      </Container>
    );
  }

  const styles = {
    listItem: {
      display: "block",
      width: "100%",
      border: `1px solid ${brandColors.divider}`,
      margin: "16px auto",
      padding: "20px",
      backgroundColor: brandColors.backgroundPaper,
      borderRadius: "12px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 3px 8px rgba(0,0,0,0.4)",
      },
    },
    contUser: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      alignItems: "center",
      rowGap: "8px",
      marginBottom: "16px",
      padding: "12px 16px",
      backgroundColor: brandColors.backgroundDefault,
      borderBottom: `1px solid ${brandColors.divider}`,
      borderRadius: "8px 8px 0 0",
    },
    textField: {
      marginBottom: "30px",
    },
    contList: {
      marginTop: "-30px",
    },
    name: {
      color: brandColors.accent,
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "15px",
      marginTop: "15px",
    },
    title: {
      fontSize: "20px",
      fontWeight: "600",
      color: brandColors.textPrimary,
      marginBottom: "15px",
    },
    titlee: {
      color: brandColors.textPrimary,
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "12px",
      lineHeight: 1.4,
    },
    descriptionn: {
      color: brandColors.textSecondary,
      fontSize: "15px",
      lineHeight: 1.6,
      marginBottom: "16px",
    },
    offer: {
      fontSize: "17px",
      marginBottom: "16px",
      backgroundColor: brandColors.backgroundDefault,
      color: brandColors.accent,
      padding: "12px 16px",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontWeight: "500",
    },
    url: {
      marginBottom: "15px",
    },
    description: {
      marginBottom: "15px",
      fontWeight: "300",
    },
    cupon: {
      color: "#a0b4ff",
      padding: "3px",
      borderRadius: "3px",
      backgroundColor: "#1a1a2e",
      fontSize: "20px",
      marginBottom: "15px",
    },
    created: {
      fontSize: "10px",
      marginBottom: "15px",
    },
    media: {
      width: "130px",
      marginTop: "20px",
    },
    event: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "16px",
      fontWeight: "500",
      color: brandColors.accent,
      marginBottom: "12px",
      padding: "8px 12px",
      backgroundColor: brandColors.backgroundDefault,
      borderRadius: "8px",
    },
    date: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      color: brandColors.accent,
      fontSize: "16px",
      fontWeight: "500",
      marginBottom: "16px",
      padding: "8px 12px",
      backgroundColor: brandColors.backgroundDefault,
      borderRadius: "8px",
    },
    list: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      margin: "auto",
      marginBottom: "100px",
    },
    listi: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      padding: "15px",
      width: "100%",
      margin: "auto",
      marginBottom: "20px",
      boxShadow: "0px 0px 5px 0px rgba(255,255,255,0.1)",
    },
    namee: {
      fontSize: "20px",
      color: "#a0b4ff",
      padding: "10px",
    },
    imageGrid: {
      marginTop: "15px",
      marginBottom: "15px",
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    noImage: {
      width: "100%",
      height: "100px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: brandColors.backgroundDefault,
      color: brandColors.textSecondary,
    },
    offerImageContainer: {
      position: "relative",
      width: "100%",
      borderRadius: "6px",
      overflow: "hidden",
      backgroundColor: "#111",
      aspectRatio: "1/1",
    },
    offerMainImage: {
      display: "block",
      width: "100%",
      height: "100%",
      objectFit: "contain",
      backgroundColor: "#222",
      transition: "transform 0.3s ease",
      "&:hover": {
        transform: "scale(1.03)",
      },
    },
    eventImageContainer: {
      position: "relative",
      width: "100%",
      borderRadius: "6px",
      overflow: "hidden",
      backgroundColor: brandColors.backgroundDefault,
      aspectRatio: "9/16",
    },
    eventMainImage: {
      display: "block",
      width: "100%",
      height: "100%",
      objectFit: "contain",
      backgroundColor: brandColors.backgroundDefault,
      transition: "transform 0.3s ease",
      "&:hover": {
        transform: "scale(1.02)",
      },
    },
    additionalImagesOverlay: {
      position: "absolute",
      bottom: "10px",
      right: "10px",
      width: "60px", // Adjust width as needed
      height: "60px", // Adjust height as needed
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      cursor: "pointer",
    },
    additionalImagesCount: {
      fontSize: "18px", // Adjust font size as needed
      fontWeight: "bold",
    },
    // Puntitos tipo Instagram sobre la miniatura de la card, para que se note
    // que hay más de una imagen sin tener que abrir el slideshow.
    thumbnailDots: {
      position: "absolute",
      bottom: "8px",
      left: "50%",
      transform: "translateX(-50%)",
      display: "flex",
      gap: "4px",
      zIndex: 1,
      pointerEvents: "none",
    },
    thumbnailDot: {
      width: "5px",
      height: "5px",
      borderRadius: "50%",
      backgroundColor: "rgba(255,255,255,0.5)",
    },
    thumbnailDotActive: {
      backgroundColor: "#fff",
    },
    imageModalContent: {
      position: "relative",
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    imageModalImage: {
      maxWidth: "100%",
      maxHeight: "80vh",
      width: "auto",
      height: "auto",
      objectFit: "contain",
      userSelect: "none",
    },
    imageModalTopBar: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px 12px",
      zIndex: 2,
    },
    imageModalCounter: {
      color: "#fff",
      backgroundColor: "rgba(0,0,0,0.5)",
      borderRadius: "12px",
      padding: "2px 10px",
      fontSize: "13px",
    },
    imageModalNavButton: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      backgroundColor: "rgba(0,0,0,0.4)",
      color: "#fff",
      "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
      zIndex: 2,
    },
    imageModalDots: {
      display: "flex",
      justifyContent: "center",
      gap: "6px",
      marginTop: "12px",
      flexWrap: "wrap",
      maxWidth: "80%",
    },
    imageModalDot: {
      width: "7px",
      height: "7px",
      borderRadius: "50%",
      backgroundColor: "rgba(255,255,255,0.35)",
      cursor: "pointer",
    },
    imageModalDotActive: {
      backgroundColor: "#fff",
    },
  };

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: { xs: "100%", md: "980px" },
        mx: "auto",
        borderLeft: `1px solid ${brandColors.divider}`,
        borderRight: `1px solid ${brandColors.divider}`,
        position: "relative",
      }}
    >
      <Box>
        <ProfileHeader />
      </Box>
      <Container
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          height: "auto",
          mt: { xs: 8, sm: 10 },
        }}
      >
        {profile && (() => {
          // Cabecera tipo Instagram. Compu: foto grande a la izquierda y todo
          // el texto a la derecha. Celular: foto chica con nombre y contadores
          // al costado; contacto, botón y tiendas abajo a todo el ancho.
          const actionBtnSx = {
            color: brandColors.accent,
            borderColor: brandColors.accent,
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { borderColor: brandColors.accent, backgroundColor: alpha(brandColors.accent, 0.08) },
          };
          const actionButton = profileUid === auth.currentUser?.uid ? (
            <Button variant="outlined" size="small" fullWidth={!isWideHeader} sx={actionBtnSx} onClick={() => navigate("/edit")}>
              <T>Editar Perfil</T>
            </Button>
          ) : (
            !isPrivateForViewer && (
              <Button variant="outlined" size="small" fullWidth={!isWideHeader} startIcon={<ChatIcon />} sx={actionBtnSx} onClick={handleStartDirectChat}>
                <T>Enviar mensaje</T>
              </Button>
            )
          );
          const contactLines = isPrivateForViewer ? (
            <Typography sx={{ fontWeight: "bold" }}>
              <T>Perfil privado</T>
            </Typography>
          ) : (
            <>
              {[profile.email, profile.phone, profile.point].filter(Boolean).map((line) => (
                <Typography key={line} variant="body2" sx={{ color: brandColors.textSecondary, overflowWrap: "anywhere" }} component="div">
                  {line}
                </Typography>
              ))}
              {/* Se valida de nuevo al mostrar: el doc users/{uid} se puede
                  escribir sin pasar por EditProfile (ver utils/safeUrl.js). */}
              {normalizeWebsite(profile.website) && (
                <Typography
                  variant="body2"
                  component="a"
                  href={normalizeWebsite(profile.website)}
                  target="_blank"
                  rel="noopener noreferrer nofollow ugc"
                  sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, color: brandColors.accent, fontWeight: 600, textDecoration: "none", overflowWrap: "anywhere", "&:hover": { textDecoration: "underline" } }}
                >
                  <LanguageIcon sx={{ fontSize: 16 }} />
                  {websiteLabel(normalizeWebsite(profile.website))}
                </Typography>
              )}
              {/* Solo el dueño del perfil, y solo si todavía no cargó uno. */}
              {!normalizeWebsite(profile.website) && profileUid === auth.currentUser?.uid && (
                <Box>
                  <Button
                    size="small"
                    startIcon={<LanguageIcon sx={{ fontSize: "16px !important" }} />}
                    onClick={() => navigate("/edit")}
                    sx={{ textTransform: "none", fontWeight: 600, color: brandColors.accent, px: 0.5, ml: -0.5, minWidth: 0 }}
                  >
                    <T>Agregar sitio web</T>
                  </Button>
                </Box>
              )}
            </>
          );
          // Publicaciones siempre (salvo perfil privado); seguidores y
          // seguidos solo si el perfil no los oculta (mostrarSeguidores).
          const countItems = isPrivateForViewer ? [] : [
            [postsCount ?? "–", <T>Publicaciones</T>],
            ...(canSeeFollowCounts ? [
              [followingCount, <T>Siguiendo</T>, () => setFollowListTab("following")],
              [followersCount, <T>Seguidores</T>, () => setFollowListTab("followers")],
            ] : []),
          ];
          const counts = countItems.length > 0 && (
            <Box sx={{ display: "flex", gap: isWideHeader ? 3 : 1, justifyContent: isWideHeader ? "flex-start" : "space-between", maxWidth: isWideHeader ? "none" : 260 }}>
              {countItems.map(([count, label, onOpen], i) => {
                const clickableSx = onOpen
                  ? { cursor: "pointer", borderRadius: 1, "&:hover .count-label": { color: "text.primary", textDecoration: "underline" } }
                  : {};
                const clickProps = onOpen
                  ? { role: "button", tabIndex: 0, onClick: onOpen, onKeyDown: (e) => (e.key === "Enter" || e.key === " ") && onOpen() }
                  : {};
                return isWideHeader ? (
                  <Typography key={i} variant="body1" sx={clickableSx} {...clickProps}>
                    <b>{count}</b> <Box component="span" className="count-label" sx={{ color: "text.secondary" }}>{label}</Box>
                  </Typography>
                ) : (
                  <Box key={i} sx={{ textAlign: "center", ...clickableSx }} {...clickProps}>
                    <Typography sx={{ fontWeight: 700, lineHeight: 1.2 }}>{count}</Typography>
                    <Typography className="count-label" sx={{ color: "text.secondary", fontSize: "0.75rem" }}>{label}</Typography>
                  </Box>
                );
              })}
            </Box>
          );
          const storeChips = stores.length > 0 && (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {stores.map((store) => (
                <Chip
                  key={store.id}
                  icon={<StorefrontIcon />}
                  label={store.storeName}
                  variant="outlined"
                  size="small"
                  onClick={() => navigate(`/stores/${store.slug}`)}
                  sx={{ cursor: "pointer", color: brandColors.accent, borderColor: brandColors.accent, "& .MuiChip-icon": { color: brandColors.accent } }}
                />
              ))}
            </Box>
          );
          const nameRow = (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
              <Typography
                variant="h5"
                component="h1"
                sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0, fontSize: isWideHeader ? "1.5rem" : "1.15rem", fontWeight: 600, overflowWrap: "anywhere" }}
              >
                {profile.displayName}
                {verifiedUids.includes(profileUid) && <VerifiedBadge />}
                {officialUids.includes(profileUid) && <OfficialBadge />}
              </Typography>
              {isWideHeader && <Box sx={{ ml: 1 }}>{actionButton}</Box>}
              <IconButton
                sx={{ ml: "auto", color: brandColors.accent, flexShrink: 0 }}
                onClick={(e) => setProfileMenuAnchorEl(e.currentTarget)}
                aria-label="more options"
              >
                <MoreVertIcon />
              </IconButton>
            </Box>
          );

          return (
            <>
              <Box sx={{ width: "100%", maxWidth: 760, display: "flex", alignItems: "center", gap: isWideHeader ? 5 : 2.5, mt: 2, mb: 2 }}>
                <Avatar
                  alt={profile.displayName}
                  src={profile.profileImageUrl}
                  sx={{
                    width: isWideHeader ? 150 : 86,
                    height: isWideHeader ? 150 : 86,
                    flexShrink: 0,
                    border: `${isWideHeader ? 4.5 : 3}px solid ${brandColors.divider}`,
                  }}
                />
                <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: isWideHeader ? 1.5 : 1 }}>
                  {nameRow}
                  {counts}
                  {isWideHeader && <Box>{contactLines}</Box>}
                  {isWideHeader && storeChips}
                </Box>
              </Box>
              {!isWideHeader && (
                <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 1.5, mb: 2 }}>
                  <Box>{contactLines}</Box>
                  {actionButton}
                  {storeChips}
                </Box>
              )}
            {profile && (
              <Menu
                anchorEl={profileMenuAnchorEl}
                open={Boolean(profileMenuAnchorEl)}
                onClose={() => setProfileMenuAnchorEl(null)}
              >
                {profileUid !== auth.currentUser?.uid && (
                  <MenuItem
                    onClick={() => {
                      handleFollow(profileUid);
                      setProfileMenuAnchorEl(null);
                    }}
                    disabled={loading}
                  >
                    {following.includes(profileUid) ? <T>Dejar de seguir</T> : <T>Seguir</T>}
                  </MenuItem>
                )}
                <MenuItem
                  onClick={() => {
                    if (navigator.share) {
                      navigator.share({
                        title: profile.displayName,
                        url: `${window.location.origin}/profile/${profileUid}`,
                      }).catch(() => {});
                    }
                    setProfileMenuAnchorEl(null);
                  }}
                >
                  <T>Compartir perfil</T>
                </MenuItem>
                {profileUid !== auth.currentUser?.uid && (
                  <MenuItem
                    onClick={() => {
                      if (auth.currentUser) {
                        reportItem({
                          reporterId: auth.currentUser.uid,
                          targetType: "profile",
                          targetId: profileUid,
                          companyId: profileUid,
                        });
                      }
                      setProfileMenuAnchorEl(null);
                    }}
                  >
                    <T>Reportar</T>
                  </MenuItem>
                )}
                {profileUid !== auth.currentUser?.uid && (
                  isBlocked ? (
                    <MenuItem
                      onClick={() => {
                        handleUnblockUser();
                        setProfileMenuAnchorEl(null);
                      }}
                    >
                      <T>Desbloquear usuario</T>
                    </MenuItem>
                  ) : (
                    <MenuItem
                      onClick={() => {
                        handleBlockUser();
                        setProfileMenuAnchorEl(null);
                      }}
                    >
                      <T>Bloquear usuario</T>
                    </MenuItem>
                  )
                )}
              </Menu>
            )}
            </>
          );
        })()}
      </Container>

      <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="profile tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          textColor="inherit"
          TabIndicatorProps={{ style: { backgroundColor: brandColors.accent } }}
          sx={{ "& .MuiTab-root": { color: brandColors.textSecondary }, "& .Mui-selected": { color: brandColors.accent }, "& .MuiTabs-scrollButtons": { color: brandColors.textSecondary } }}
        >
          <Tab label={<T>Ofertas</T>} {...a11yProps(tabIndex("ofertas"))} />
          <Tab label={<T>Eventos</T>} {...a11yProps(tabIndex("eventos"))} />
          <Tab label={<T>Tiendas</T>} {...a11yProps(tabIndex("tiendas"))} />
          <Tab label={<T>Hilos</T>} {...a11yProps(tabIndex("hilos"))} />
          {hasCars && (
            <Tab label={<T>Autos</T>} {...a11yProps(tabIndex("autos"))} />
          )}
          {hasPlaces && (
            <Tab label={<T>Propiedades</T>} {...a11yProps(tabIndex("propiedades"))} />
          )}
        </Tabs>
      </Box>
      <Box sx={{ width: "100%", px: 2, pt: 2 }}>
        <TextField
          fullWidth
          size="small"
          placeholder={
            value === tabIndex("ofertas")
              ? "Buscar oferta..."
              : value === tabIndex("eventos")
              ? "Buscar evento..."
              : value === tabIndex("tiendas")
              ? "Buscar tienda..."
              : value === tabIndex("hilos")
              ? "Buscar hilo..."
              : value === tabIndex("autos")
              ? "Buscar auto..."
              : "Buscar propiedad..."
          }
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            endAdornment: <SearchClearAdornment value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          width: "100%",
          pb: "64px",
        }}
      >
        <TabPanel value={value} index={tabIndex("ofertas")}>
          {filteredOffers.length === 0 ? (
            <Typography color="text.secondary" sx={{ mt: 2 }}>
              <T>No hay resultados.</T>
            </Typography>
          ) : (
          <List style={styles.list}>
            {filteredOffers
              .slice(0, offersLimit)
              .map((offerData, index) => (
              <ListItem key={offerData.id} sx={{ ...styles.listItem, ...feedPostSx, mt: { xs: 0, sm: 2 } }}>
                <Box sx={{ ...styles.contUser, ...feedPostHeaderSx, borderRadius: { xs: 0, sm: "8px 8px 0 0" }, mb: { xs: 0, sm: 2 } }}>
                  <CardMedia
                    component="img"
                    image={authorPhotos[offerData.uid] || offerData.image}
                    title="Perfil"
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      marginRight: 16,
                      border: `2.5px solid ${brandColors.divider}`,
                    }}
                  />
                  <Box
                    onClick={() => navigate(`/profile/${offerData.uid}`)}
                    sx={{ textDecoration: "none", display: "flex", alignItems: "center", cursor: "pointer" }}
                  >
                    <Typography style={styles.name}>{offerData.name}</Typography>
                    {verifiedUids.includes(offerData.uid) && <VerifiedBadge />}
                    {officialUids.includes(offerData.uid) && <OfficialBadge />}
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.5, ml: "auto" }}>
                    {!isCompanyFollowed(offerData.uid) && offerData.uid !== auth.currentUser?.uid && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleFollow(offerData.uid)}
                        disabled={loading || !userAuthenticated}
                        sx={{ textTransform: "none", borderColor: brandColors.primary, color: brandColors.accent }}
                      >
                        <T>Seguir</T>
                      </Button>
                    )}

                    {userAuthenticated && (
                      <IconButton
                        size="small"
                        onClick={() => handleToggleSaveClick(offerData)}
                        aria-label={savedOfferIds.includes(offerData.id) ? "quitar de guardados" : "guardar"}
                      >
                        {savedOfferIds.includes(offerData.id) ? <BookmarkIcon fontSize="small" /> : <BookmarkBorderIcon fontSize="small" />}
                      </IconButton>
                    )}

                    <IconButton size="small" onClick={(e) => handleOpenPostMenu(e, offerData, "offers")} aria-label="more options">
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "flex-start",
                    alignItems: "center",
                    width: "100%",
                    mt: { xs: 0, sm: 3 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      flexDirection: "column",
                      width: { xs: "100%", md: "20%" },
                      alignItems: { xs: "center", md: "flex-start" },
                      mb: { xs: 1.5, sm: 3, md: 0 },
                    }}
                  >
                    {offerData.videos && offerData.videos.length > 0 ? (
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          paddingBottom:
                            aspectRatio === "16:9" ? "56.25%" : "177.78%", // Aspecto dinámico para 16:9 y 9:16
                          backgroundColor: "#000", // Fondo para cuando el video no se carga
                          overflow: "hidden",
                          borderRadius: feedPostMediaRadius,
                        }}
                      >
                        <video
                          src={offerData.videos[0]}
                          controls
                          muted
                          playsInline
                          autoPlay
                          onLoadedMetadata={handleLoadedMetadata}
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            objectFit: "cover", // Ajusta el video sin distorsión
                          }}
                        />
                      </Box>
                    ) : offerData.images && offerData.images.length > 0 ? (
                      <Box sx={{ ...styles.offerImageContainer, borderRadius: feedPostMediaRadius }}>
                        <CardMedia
                          component="img"
                          image={offerData.images[0]}
                          alt={`Imagen principal de ${offerData.name}`}
                          sx={styles.offerMainImage}
                          onClick={() => handleOpenImageModal(offerData.images)}
                          style={{ cursor: "pointer" }}
                        />
                        {offerData.images.length > 1 && (
                          <>
                            <Box style={styles.thumbnailDots}>
                              {offerData.images.slice(0, 8).map((_, i) => (
                                <Box
                                  key={i}
                                  style={{
                                    ...styles.thumbnailDot,
                                    ...(i === 0 ? styles.thumbnailDotActive : {}),
                                  }}
                                />
                              ))}
                            </Box>
                            <Box
                              style={styles.additionalImagesOverlay}
                              onClick={() =>
                                handleOpenImageModal(offerData.images)
                              }
                            >
                              <Typography style={styles.additionalImagesCount}>
                                +{offerData.images.length - 1}
                              </Typography>
                              <Typography><T>Ver más</T></Typography>
                            </Box>
                          </>
                        )}
                      </Box>
                    ) : (
                      <Box style={styles.noImage}>
                        <Typography><T>No hay medios disponibles</T></Typography>
                      </Box>
                    )}
                  </Box>

                  <Box
                    sx={{
                      width: { xs: "100%", md: "70%" },
                      pl: { xs: 1.5, sm: 0, md: 3 },
                      pr: { xs: 1.5, sm: 0 },
                    }}
                  >
                      <Typography component={RouterLink} to={`/offers/${offerData.id}`} style={styles.title} sx={{ color: "inherit", textDecoration: "none", display: "block", "&:hover": { textDecoration: "underline" } }}>
                        {offerData.product || offerData.title}
                      </Typography>
                    <Typography
                      color="text.secondary"
                      sx={{ mb: 1, fontSize: "12px" }}
                    >
                      <T>A</T> {offerData.helpedCount || 0} <T>personas les sirvio esta oferta</T>
                    </Typography>
                    <Typography style={styles.description}>
                      {offerData.description}
                    </Typography>
                    {offerData.price && (
                      <DiscountPriceBreakdown
                        originalPrice={Number(offerData.price)}
                        discountPercent={Number(offerData.offer) || 0}
                        finalPrice={Number(offerData.price) * (1 - (Number(offerData.offer) || 0) / 100)}
                      />
                    )}
                    <OfferPaymentBadges offer={offerData} />
                    {offerData.cupon && <CopyToClipboardComponent textToCopy={offerData.cupon} offer={offerData} />}
                    <OfferBuyButton offer={offerData} />
                    {offerData.url && (
                      <Button
                        variant="contained"
                        color="primary"
                        href={!offerData.url.startsWith("http") ? `http://${offerData.url}` : offerData.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ width: "100%", mt: 1, mb: 1 }}
                      >
                        <T>Comprar en</T> {getDomainFromUrl(offerData.url)}
                      </Button>
                    )}
                      <InterestButton
                        liked={!!userLikes[offerData.id]}
                        count={formatCount(offerData.helpedCount || 0)}
                        onClick={() => handleMeSirveClick(offerData.id)}
                        disabled={!userAuthenticated}
                        sx={{ mt: 2, mb: 2 }}
                      />
                    <Typography style={styles.created}>
                      <T>Fecha de publicación:</T> {formatDate(offerData.createdAt)}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ mt: { xs: 2, sm: 3 }, borderTop: `1px solid ${brandColors.divider}`, pt: 2, width: "100%", px: feedPostTextPx, pb: { xs: 1.5, sm: 0 }, boxSizing: "border-box" }}>
                      <Box
                        onClick={() => setShowQA((prev) => ({ ...prev, [offerData.id]: !prev[offerData.id] }))}
                        sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}
                      >
                        <ForumOutlinedIcon sx={{ fontSize: 20, color: brandColors.textSecondary }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, flexGrow: 1, display: "flex", alignItems: "center" }}>
                          <T>Preguntas y Respuestas</T>
                          {(questionsAndAnswers[offerData.id]?.length ?? 0) > 0 && (
                            <Box
                              component="span"
                              sx={{ ml: 0.75, px: 1, py: 0.125, borderRadius: "999px", fontSize: "0.75rem", fontWeight: 700, backgroundColor: "rgba(127,127,127,0.25)" }}
                            >
                              {questionsAndAnswers[offerData.id].length}
                            </Box>
                          )}
                        </Typography>
                        {showQA[offerData.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </Box>
                      {showQA[offerData.id] && (
                      <>
                      {!questionsAndAnswers[offerData.id]?.length && (
                        <Box sx={{ textAlign: "center", py: 3 }}>
                          <ForumOutlinedIcon sx={{ fontSize: 32, color: brandColors.divider, mb: 1 }} />
                          <Typography variant="body2" sx={{ color: brandColors.textSecondary }}>
                            <T>Todavía no hay preguntas. ¡Sé el primero en preguntar!</T>
                          </Typography>
                        </Box>
                      )}
                      <List dense sx={{ p: 0, mt: 1 }}>
                        {questionsAndAnswers[offerData.id]?.slice(0, showMoreQuestions[offerData.id] ? undefined : 1).map((item) => (
                          <ListItem key={item.id} alignItems="flex-start" sx={{ p: 0, mb: 1.5 }}>
                            <Paper variant="outlined" sx={{ p: 1.75, width: "100%", borderRadius: 2, bgcolor: brandColors.backgroundPaper, borderColor: brandColors.divider }}>
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <Avatar src={item.profileImageUrl} alt={item.displayName} sx={{ width: 32, height: 32 }} />
                                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                  <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.75, flexWrap: "wrap" }}>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.displayName}</Typography>
                                    {item.createdAt && (
                                      <Typography variant="caption" sx={{ color: brandColors.textSecondary }}>
                                        {formatDate(item.createdAt)}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Typography variant="body2" sx={{ mt: 0.25 }}>{item.question}</Typography>
                                </Box>
                              </Box>
                              {item.answers.map((answer) => (
                                <Box key={answer.id} sx={{ display: "flex", gap: 1, mt: 1.5, pl: 2, borderLeft: `2px solid ${brandColors.divider}` }}>
                                  <Avatar src={answer.profileImageUrl} alt={answer.displayName} sx={{ width: 26, height: 26 }} />
                                  <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                    <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.75, flexWrap: "wrap" }}>
                                      <Typography variant="body2" sx={{ fontWeight: 600, color: brandColors.accent }}>{answer.displayName}</Typography>
                                      {answer.createdAt && (
                                        <Typography variant="caption" sx={{ color: brandColors.textSecondary }}>
                                          {formatDate(answer.createdAt)}
                                        </Typography>
                                      )}
                                    </Box>
                                    <Typography variant="body2" sx={{ mt: 0.25 }}>{answer.answer}</Typography>
                                  </Box>
                                </Box>
                              ))}
                              {auth.currentUser?.uid === offerData.uid &&
                                !item.answers.length && (
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1.5, pl: 2 }}>
                                    <TextField
                                      fullWidth
                                      variant="standard"
                                      size="small"
                                      placeholder="Escribe una respuesta..."
                                      value={newAnswer[item.id] || ""}
                                      onChange={(e) =>
                                        setNewAnswer((prevAnswers) => ({
                                          ...prevAnswers,
                                          [item.id]: e.target.value,
                                        }))
                                      }
                                      inputRef={(ref) =>
                                        (answerInputRef.current[item.id] =
                                          ref)
                                      }
                                    />
                                    <IconButton
                                      size="small"
                                      color="primary"
                                      onClick={() =>
                                        handleAnswerSubmit(
                                          item.id,
                                          offerData.id
                                        )
                                      }
                                      disabled={!newAnswer[item.id]?.trim()}
                                    >
                                      <SendIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                )}
                            </Paper>
                          </ListItem>
                        ))}
                      </List>
                      {(questionsAndAnswers[offerData.id]?.length ?? 0) > 1 && (
                        <Button
                          size="small"
                          onClick={() =>
                            setShowMoreQuestions((prev) => ({
                              ...prev,
                              [offerData.id]: !prev[offerData.id],
                            }))
                          }
                          sx={{ mt: 0, textTransform: "none", fontSize: "0.8rem" }}
                        >
                          {showMoreQuestions[offerData.id]
                            ? <T>Mostrar menos</T>
                            : <><T>Mostrar</T> {questionsAndAnswers[offerData.id].length - 1} <T>más</T></>}
                        </Button>
                      )}

                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1.5 }}>
                        <TextField
                          fullWidth
                          placeholder="Escribe una pregunta..."
                          size="small"
                          value={newQuestion[offerData.id] || ""}
                          onChange={(e) => setNewQuestion((prev) => ({ ...prev, [offerData.id]: e.target.value }))}
                          sx={{
                            "& .MuiOutlinedInput-root": { borderRadius: "999px", bgcolor: brandColors.inputBackground },
                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                          }}
                        />
                        <IconButton
                          onClick={() => handleQuestionSubmit(offerData.id)}
                          disabled={!newQuestion[offerData.id]?.trim()}
                          sx={{
                            bgcolor: brandColors.primary,
                            color: "#fff",
                            "&:hover": { bgcolor: brandColors.primaryHover },
                            "&.Mui-disabled": { bgcolor: "rgba(127,127,127,0.25)", color: brandColors.textSecondary },
                          }}
                        >
                          <SendIcon fontSize="small" />
                        </IconButton>
                      </Box>
                      </>
                      )}
                </Box>
              </ListItem>
            ))}
          </List>
          )}
          {filteredOffers.length > offersLimit && <Box ref={offersSentinelRef} sx={{ height: 1 }} />}
        </TabPanel>
        <TabPanel value={value} index={tabIndex("eventos")}>
          {!loadedTabs.includes("eventos") ? (
            tabLoadingSpinner
          ) : filteredEvents.length === 0 ? (
            <Typography color="text.secondary" sx={{ mt: 2 }}>
              <T>No hay resultados.</T>
            </Typography>
          ) : (
          <List style={styles.list}>
            {filteredEvents
              .slice(0, eventsLimit)
              .map((eventData, index) => (
              <ListItem key={eventData.id} sx={{ ...styles.listItem, ...feedPostSx, mt: { xs: 0, sm: 2 } }}>
                <Box sx={{ ...styles.contUser, ...feedPostHeaderSx, borderRadius: { xs: 0, sm: "8px 8px 0 0" }, mb: { xs: 0, sm: 2 } }}>
                  <CardMedia
                    component="img"
                    image={authorPhotos[eventData.uid] || eventData.image}
                    title="Perfil"
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      marginRight: 16,
                      border: `2.5px solid ${brandColors.divider}`,
                    }}
                  />
                  <Box
                    onClick={() => navigate(`/profile/${eventData.uid}`)}
                    sx={{ textDecoration: "none", display: "flex", alignItems: "center", cursor: "pointer" }}
                  >
                    <Typography style={styles.name}>{eventData.name}</Typography>
                    {verifiedUids.includes(eventData.uid) && <VerifiedBadge />}
                    {officialUids.includes(eventData.uid) && <OfficialBadge />}
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.5, ml: "auto" }}>
                    {!isCompanyFollowed(eventData.uid) && eventData.uid !== auth.currentUser?.uid && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleFollow(eventData.uid)}
                        disabled={loading}
                        sx={{ textTransform: "none", borderColor: brandColors.primary, color: brandColors.accent }}
                      >
                        <T>Seguir</T>
                      </Button>
                    )}
                    {!!auth.currentUser && (
                      <IconButton
                        size="small"
                        onClick={() => handleToggleSaveEventClick(eventData)}
                        aria-label={savedEventIds.includes(eventData.id) ? "quitar de guardados" : "guardar"}
                      >
                        {savedEventIds.includes(eventData.id) ? <BookmarkIcon fontSize="small" /> : <BookmarkBorderIcon fontSize="small" />}
                      </IconButton>
                    )}
                    <IconButton size="small" onClick={(e) => handleOpenPostMenu(e, eventData, "events")} aria-label="more options">
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    width: "100%",
                    mt: { xs: 0, sm: 2 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: { xs: "100%", md: "30%" },
                      pr: { xs: 0, md: 2 },
                      alignItems: { xs: "center", md: "flex-start" },
                      mb: { xs: 1.5, sm: 2, md: 0 },
                    }}
                  >
                    {eventData.videos && eventData.videos.length > 0 ? (
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          paddingBottom: aspectRatio === "16:9" ? "56.25%" : "177.78%",
                          backgroundColor: "#000",
                          overflow: "hidden",
                          borderRadius: feedPostMediaRadius,
                        }}
                      >
                        <video
                          src={eventData.videos[0]}
                          controls
                          autoPlay
                          playsInline
                          onLoadedMetadata={handleLoadedMetadata}
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                          muted={false}
                        />
                      </Box>
                    ) : eventData.images && eventData.images.length > 0 ? (
                      <Box sx={{ ...styles.eventImageContainer, borderRadius: feedPostMediaRadius }}>
                        <CardMedia
                          component="img"
                          image={eventData.images[0]}
                          alt={`Imagen principal de ${eventData.name}`}
                          sx={styles.eventMainImage}
                          onClick={() => handleOpenImageModal(eventData.images)}
                          style={{ cursor: "pointer" }}
                        />
                        {eventData.images.length > 1 && (
                          <>
                            <Box style={styles.thumbnailDots}>
                              {eventData.images.slice(0, 8).map((_, i) => (
                                <Box
                                  key={i}
                                  style={{
                                    ...styles.thumbnailDot,
                                    ...(i === 0 ? styles.thumbnailDotActive : {}),
                                  }}
                                />
                              ))}
                            </Box>
                            <Box
                              style={styles.additionalImagesOverlay}
                              onClick={() =>
                                handleOpenImageModal(eventData.images)
                              }
                            >
                              <Typography style={styles.additionalImagesCount}>
                                +{eventData.images.length - 1}
                              </Typography>
                              <Typography><T>Ver más</T></Typography>
                            </Box>
                          </>
                        )}
                      </Box>
                    ) : (
                      <Box style={styles.noImage}>
                        <Typography><T>No hay medios disponibles</T></Typography>
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: { xs: "100%", md: "70%" },
                      px: feedPostTextPx,
                    }}
                  >
                    <Typography component={RouterLink} to={`/events/${eventData.id}`} style={styles.titlee} sx={{ color: "inherit", textDecoration: "none", display: "block", "&:hover": { textDecoration: "underline" } }}>{eventData.title}</Typography>
                    {(eventData.isPrivate || eventData.isPaid) && (
                      <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
                        {eventData.isPrivate && (
                          <Chip
                            size="small"
                            icon={<LockIcon sx={{ fontSize: 16 }} />}
                            label={<T>Privado</T>}
                            sx={{ backgroundColor: alpha(brandColors.accent, 0.15), color: brandColors.accent }}
                          />
                        )}
                        {eventData.isPaid && (
                          <Chip
                            size="small"
                            label={`$${Number(eventData.ticketPrice).toFixed(2)}`}
                            sx={{ backgroundColor: alpha(brandColors.accent, 0.15), color: brandColors.accent }}
                          />
                        )}
                      </Box>
                    )}
                    <Typography style={styles.descriptionn}>
                      {eventData.description}
                    </Typography>
                    <Typography style={styles.event}>
                      <T>Tipo de evento:</T> {eventData.eventType}
                    </Typography>
                    <Typography style={styles.date}>
                      {getEventDates(eventData).length > 1 ? <T>Fechas:</T> : <T>Fecha:</T>}{" "}
                      {formatEventDatesList(eventData)}
                    </Typography>
                    <EventCountdown event={eventData} />
                    {eventData.direccion && (
                      <Typography style={styles.event}>
                        <T>Dirección:</T> {eventData.direccion}
                      </Typography>
                    )}
                    {eventData.horario && (
                      <Typography style={styles.date}>
                        <T>Horario:</T> {getHorarioLabel(eventData.horario)}
                      </Typography>
                    )}
                    <Typography style={styles.created}>
                      <T>Fecha de publicación:</T> {formatDate(eventData.createdAt)}
                    </Typography>
                    {eventData.isPaid && !eventData.paypalEmail && eventData.url && (
                      <Button
                        fullWidth
                        component="a"
                        href={safeHttpUrl(eventData.url) || undefined}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        sx={{
                          backgroundColor: brandColors.action,
                          color: brandColors.onAction,
                          borderColor: brandColors.action,
                          "&:hover": { backgroundColor: brandColors.actionHover },
                          mt: 1,
                        }}
                      >
                        <T>Comprar entrada</T> (${Number(eventData.ticketPrice).toFixed(2)})
                      </Button>
                    )}
                    {sellsTicketsWithPaypal(eventData) &&
                    eventData.uid !== auth.currentUser?.uid &&
                    !eventData.ticketBuyers?.includes(auth.currentUser?.uid) ? (
                      purchasingEventId === eventData.id ? (
                        <Box sx={{ width: "100%", mt: 1, mb: 1 }}>
                          <PaypalButton
                            amount={eventData.ticketPrice}
                            currency="USD"
                            description={`Entrada: ${eventData.title}`}
                            clientId={process.env.REACT_APP_PAYPAL_CLIENT_ID}
                            payeeEmail={eventData.paypalEmail}
                            metadata={{ customId: eventData.id }}
                            onApprove={(details) => handleTicketPurchaseApproved(eventData, details)}
                          />
                          <Button
                            size="small"
                            onClick={() => setPurchasingEventId(null)}
                            sx={{ mt: 1, textTransform: "none" }}
                          >
                            <T>Cancelar</T>
                          </Button>
                        </Box>
                      ) : (
                        <Button
                          fullWidth
                          onClick={() => setPurchasingEventId(eventData.id)}
                          disabled={loading}
                          sx={{
                            backgroundColor: brandColors.action,
                            color: brandColors.onAction,
                            borderColor: brandColors.action,
                            "&:hover": { backgroundColor: brandColors.actionHover },
                            mt: 1,
                            mb: 1,
                          }}
                        >
                          <T>Comprar entrada</T> (${Number(eventData.ticketPrice).toFixed(2)})
                        </Button>
                      )
                    ) : (
                      <Button
                        fullWidth
                        onClick={() => handleAttendEvent(eventData.id)}
                        disabled={loading}
                        sx={{
                          backgroundColor: brandColors.action,
                          color: brandColors.onAction,
                          borderColor: brandColors.action,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                          "&:hover": { backgroundColor: brandColors.primaryHover },
                          mt: 1,
                          mb: 1,
                        }}
                      >
                        {attendees[eventData.id]?.length > 0 && (
                          <AvatarGroup
                            max={3}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenAttendeesDialog(eventData.id);
                            }}
                            sx={{
                              "& .MuiAvatar-root": {
                                width: 22,
                                height: 22,
                                fontSize: "0.7rem",
                                border: `1.5px solid ${brandColors.primary}`,
                              },
                            }}
                          >
                            {attendees[eventData.id].slice(0, 3).map((attendeeId) => (
                              <Avatar
                                key={attendeeId}
                                src={attendeeProfiles[attendeeId]?.profileImageUrl || ""}
                                alt="Avatar"
                              />
                            ))}
                          </AvatarGroup>
                        )}
                        {eventData.isPaid && eventData.ticketBuyers?.includes(auth.currentUser?.uid) && eventData.uid !== auth.currentUser?.uid
                          ? <T>Ya tenés tu entrada</T>
                          : attendees[eventData.id]?.includes(auth.currentUser?.uid)
                          ? <T>No asistiré</T>
                          : <T>Asistiré</T>}
                        {" "}({formatCount(attendees[eventData.id]?.length || 0)})
                      </Button>
                    )}
                    {eventData.uid === auth.currentUser?.uid && eventData.isPaid && pendingEventCommissions[eventData.id]?.amount > 0 && (
                      <Box sx={{ width: "100%", mt: 1, mb: 1, p: 1.5, backgroundColor: brandColors.backgroundDefault, borderRadius: "8px" }}>
                        <Typography variant="body2" sx={{ color: brandColors.accent, mb: 1 }}>
                          <T>Comisión de Notiline pendiente ({pendingEventCommissions[eventData.id].salesCount} entrada{pendingEventCommissions[eventData.id].salesCount !== 1 ? "s" : ""}): ${Number(pendingEventCommissions[eventData.id].amount).toFixed(2)}</T>
                        </Typography>
                        {commissionFeedback[eventData.id] && (
                          <Alert severity={commissionFeedback[eventData.id].type} sx={{ mb: 1 }}>
                            {commissionFeedback[eventData.id].message}
                          </Alert>
                        )}
                        <PaypalButton
                          amount={pendingEventCommissions[eventData.id].amount}
                          description={`Comisión Notiline - ${eventData.title}`}
                          clientId={process.env.REACT_APP_PAYPAL_CLIENT_ID}
                          payeeEmail={process.env.REACT_APP_PLATFORM_PAYPAL_EMAIL}
                          metadata={{ customId: eventData.id }}
                          onApprove={(details) => handleEventCommissionApproved(eventData, details)}
                        />
                      </Box>
                    )}
                    <InterestButton
                      liked={!!eventUserLikes[eventData.id]}
                      count={formatCount(eventData.likes?.length || 0)}
                      onClick={() => handleMeInteresaClick(eventData.id)}
                      disabled={!auth.currentUser}
                    />
                  </Box>
                </Box>

                <Box sx={{ mt: { xs: 2, sm: 3 }, borderTop: `1px solid ${brandColors.divider}`, pt: 2, width: "100%", px: feedPostTextPx, pb: { xs: 1.5, sm: 0 }, boxSizing: "border-box" }}>
                  <Box
                    onClick={() => setShowEventQA((prev) => ({ ...prev, [eventData.id]: !prev[eventData.id] }))}
                    sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}
                  >
                    <ForumOutlinedIcon sx={{ fontSize: 20, color: brandColors.textSecondary }} />
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, flexGrow: 1, display: "flex", alignItems: "center" }}>
                      <T>Preguntas y Respuestas</T>
                      {(eventQuestionsAndAnswers[eventData.id]?.length ?? 0) > 0 && (
                        <Box
                          component="span"
                          sx={{ ml: 0.75, px: 1, py: 0.125, borderRadius: "999px", fontSize: "0.75rem", fontWeight: 700, backgroundColor: "rgba(127,127,127,0.25)" }}
                        >
                          {eventQuestionsAndAnswers[eventData.id].length}
                        </Box>
                      )}
                    </Typography>
                    {showEventQA[eventData.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </Box>
                  {showEventQA[eventData.id] && (
                    <>
                      {!eventQuestionsAndAnswers[eventData.id]?.length && (
                        <Box sx={{ textAlign: "center", py: 3 }}>
                          <ForumOutlinedIcon sx={{ fontSize: 32, color: brandColors.divider, mb: 1 }} />
                          <Typography variant="body2" sx={{ color: brandColors.textSecondary }}>
                            <T>Todavía no hay preguntas. ¡Sé el primero en preguntar!</T>
                          </Typography>
                        </Box>
                      )}
                      <List dense sx={{ p: 0, mt: 1 }}>
                        {eventQuestionsAndAnswers[eventData.id]?.slice(0, showMoreEventQuestions[eventData.id] ? undefined : 1).map((item) => (
                          <ListItem key={item.id} alignItems="flex-start" sx={{ p: 0, mb: 1.5 }}>
                            <Paper variant="outlined" sx={{ p: 1.75, width: "100%", borderRadius: 2, bgcolor: brandColors.backgroundPaper, borderColor: brandColors.divider }}>
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <Avatar src={item.profileImageUrl} alt={item.displayName} sx={{ width: 32, height: 32 }} />
                                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                  <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.75, flexWrap: "wrap" }}>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.displayName}</Typography>
                                    {item.createdAt && (
                                      <Typography variant="caption" sx={{ color: brandColors.textSecondary }}>
                                        {formatDate(item.createdAt)}
                                      </Typography>
                                    )}
                                  </Box>
                                  <Typography variant="body2" sx={{ mt: 0.25 }}>{item.question}</Typography>
                                </Box>
                              </Box>
                              {item.answers.map((answer) => (
                                <Box key={answer.id} sx={{ display: "flex", gap: 1, mt: 1.5, pl: 2, borderLeft: `2px solid ${brandColors.divider}` }}>
                                  <Avatar src={answer.profileImageUrl} alt={answer.displayName} sx={{ width: 26, height: 26 }} />
                                  <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                    <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.75, flexWrap: "wrap" }}>
                                      <Typography variant="body2" sx={{ fontWeight: 600, color: brandColors.accent }}>{answer.displayName}</Typography>
                                      {answer.createdAt && (
                                        <Typography variant="caption" sx={{ color: brandColors.textSecondary }}>
                                          {formatDate(answer.createdAt)}
                                        </Typography>
                                      )}
                                    </Box>
                                    <Typography variant="body2" sx={{ mt: 0.25 }}>{answer.answer}</Typography>
                                  </Box>
                                </Box>
                              ))}
                              {auth.currentUser?.uid === eventData.uid && !item.answers.length && (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1.5, pl: 2 }}>
                                  <TextField
                                    fullWidth
                                    variant="standard"
                                    size="small"
                                    placeholder="Escribe tu respuesta..."
                                    value={newEventAnswer[item.id] || ""}
                                    onChange={(e) => setNewEventAnswer((prev) => ({ ...prev, [item.id]: e.target.value }))}
                                  />
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => handleEventAnswerSubmit(item.id, eventData.id)}
                                    disabled={!newEventAnswer[item.id]?.trim()}
                                  >
                                    <SendIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              )}
                            </Paper>
                          </ListItem>
                        ))}
                      </List>

                      {(eventQuestionsAndAnswers[eventData.id]?.length ?? 0) > 1 && (
                        <Button
                          size="small"
                          onClick={() => setShowMoreEventQuestions((prev) => ({ ...prev, [eventData.id]: !prev[eventData.id] }))}
                          sx={{ mt: 0, textTransform: "none", fontSize: "0.8rem" }}
                        >
                          {showMoreEventQuestions[eventData.id] ? <T>Mostrar menos</T> : <><T>Mostrar</T> {eventQuestionsAndAnswers[eventData.id].length - 1} <T>más</T></>}
                        </Button>
                      )}

                      {!!auth.currentUser && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1.5 }}>
                          <TextField
                            fullWidth
                            placeholder="Escribe una pregunta..."
                            size="small"
                            value={newEventQuestion[eventData.id] || ""}
                            onChange={(e) => setNewEventQuestion((prev) => ({ ...prev, [eventData.id]: e.target.value }))}
                            sx={{
                              "& .MuiOutlinedInput-root": { borderRadius: "999px", bgcolor: brandColors.inputBackground },
                              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                            }}
                          />
                          <IconButton
                            onClick={() => handleEventQuestionSubmit(eventData.id)}
                            disabled={!newEventQuestion[eventData.id]?.trim()}
                            sx={{
                              bgcolor: brandColors.primary,
                              color: "#fff",
                              "&:hover": { bgcolor: brandColors.primaryHover },
                              "&.Mui-disabled": { bgcolor: "rgba(127,127,127,0.25)", color: brandColors.textSecondary },
                            }}
                          >
                            <SendIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              </ListItem>
            ))}
          </List>
          )}
          {filteredEvents.length > eventsLimit && <Box ref={eventsSentinelRef} sx={{ height: 1 }} />}
        </TabPanel>
        <TabPanel value={value} index={tabIndex("tiendas")}>
          {stores.length === 0 ? (
            <Typography color="text.secondary"><T>Este usuario no tiene tiendas publicadas.</T></Typography>
          ) : stores.filter((store) =>
              matchesSearch(`${store.storeName || ""} ${store.description || ""}`)
            ).length === 0 ? (
            <Typography color="text.secondary" sx={{ mt: 2 }}>
              <T>No hay resultados.</T>
            </Typography>
          ) : (
            <Grid container spacing={2}>
              {stores
                .filter((store) =>
                  matchesSearch(`${store.storeName || ""} ${store.description || ""}`)
                )
                .map((store) => (
                <Grid item xs={12} sm={6} key={store.id} sx={{ minWidth: 0 }}>
                  <Paper
                    variant="outlined"
                    sx={{ p: 2.5, borderRadius: 2, cursor: "pointer", backgroundColor: brandColors.backgroundPaper, borderColor: brandColors.divider, "&:hover": { borderColor: brandColors.accent, boxShadow: `0 0 0 1px ${brandColors.accent}` } }}
                    onClick={() => navigate(`/stores/${store.slug}`)}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
                      <StorefrontIcon sx={{ color: brandColors.accent }} />
                      <Typography variant="subtitle1" fontWeight={600} noWrap sx={{ color: brandColors.textPrimary, minWidth: 0 }}>{store.storeName}</Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, overflowWrap: "anywhere" }}>
                      {store.description}
                    </Typography>
                    <Chip
                      label={`notiline.com/stores/${store.slug}`}
                      size="small"
                      variant="outlined"
                      onClick={(e) => { e.stopPropagation(); navigate(`/stores/${store.slug}`); }}
                      // Sin maxWidth, un slug largo no corta línea y ensancha
                      // la tarjeta (y con ella todo el perfil).
                      sx={{ maxWidth: "100%", color: brandColors.accent, borderColor: alpha(brandColors.accent, 0.5), "&:hover": { borderColor: brandColors.accent } }}
                    />
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
        </TabPanel>
        <TabPanel value={value} index={tabIndex("hilos")}>
          {!loadedTabs.includes("hilos") ? (
            tabLoadingSpinner
          ) : profileThreads.length === 0 ? (
            <Typography color="text.secondary"><T>Este usuario no publicó hilos todavía.</T></Typography>
          ) : profileThreads.filter((thread) =>
              matchesSearch(`${thread.text || ""} ${thread.originalText || ""}`)
            ).length === 0 ? (
            <Typography color="text.secondary" sx={{ mt: 2 }}>
              <T>No hay resultados.</T>
            </Typography>
          ) : (
            <Grid container spacing={2}>
              {profileThreads
                .filter((thread) =>
                  matchesSearch(`${thread.text || ""} ${thread.originalText || ""}`)
                )
                .map((thread) => {
                  const isRepost = !!thread.repostOf;
                  const text = isRepost ? thread.originalText : thread.text;
                  const images = isRepost ? thread.originalImages : thread.images;
                  return (
                    <Grid item xs={12} key={thread.id}>
                      <Paper
                        variant="outlined"
                        sx={{ p: 2.5, borderRadius: 2, cursor: "pointer", backgroundColor: brandColors.backgroundPaper, borderColor: brandColors.divider, "&:hover": { borderColor: brandColors.accent, boxShadow: `0 0 0 1px ${brandColors.accent}` } }}
                        onClick={() => navigate("/hilos")}
                      >
                        <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                          {isRepost ? (
                            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
                              <T>Republicó</T>
                            </Typography>
                          ) : <Box />}
                          <IconButton
                            size="small"
                            onClick={(e) => handleOpenPostMenu(e, thread, "threads")}
                            sx={{ mt: -1, mr: -1 }}
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        </Box>
                        {text && (
                          <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", mb: images?.length ? 1 : 0.5 }}>
                            {text}
                          </Typography>
                        )}
                        {images?.length > 0 && (
                          <Box
                            component="img"
                            src={images[0]}
                            alt=""
                            sx={{ width: "100%", maxHeight: 220, objectFit: "cover", borderRadius: 1, mb: 0.5 }}
                          />
                        )}
                        <Typography variant="caption" color="text.secondary">
                          {formatDate(thread.createdAt)}
                          {!thread.repostOf && thread.editedAt && <> · <T>editado</T></>}
                          {" · "}
                          {Object.keys(thread.reactions || {}).length + (thread.likes || []).length} <T>reacciones</T>
                          {" · "}
                          {thread.commentsCount || 0} <T>comentarios</T>
                        </Typography>
                      </Paper>
                    </Grid>
                  );
                })}
            </Grid>
          )}
        </TabPanel>
        {hasCars && (
          <TabPanel value={value} index={tabIndex("autos")}>
            {!loadedTabs.includes("autos") ? (
              tabLoadingSpinner
            ) : filteredCars.length === 0 ? (
              <Typography color="text.secondary" sx={{ mt: 2 }}>
                <T>No hay resultados.</T>
              </Typography>
            ) : (
              <Grid container spacing={2}>
                {filteredCars
                  .slice(0, carsLimit)
                  .map((car) => {
                    const images = Array.isArray(car.images)
                      ? car.images
                      : car.images
                      ? [car.images]
                      : [];
                    const conditionStyle = CONDITION_STYLES[car.condition];

                    return (
                    <Grid item key={car.id} xs={12} sm={6} md={4} lg={4}>
                      <Card
                        sx={{
                          borderRadius: 3,
                          backgroundColor: brandColors.backgroundPaper,
                          border: "1px solid",
                          borderColor: "divider",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate(`/cars/${car.id}`)}
                      >
                        <CardContent sx={{ flexGrow: 1 }}>
                          {/* Etiqueta y menú en su propia fila: al lado del título lo dejaban en una columna angosta. */}
                          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                            <Box>
                              <Chip
                                size="small"
                                label={conditionStyle ? conditionStyle.label : <T>No especificado</T>}
                                sx={{
                                  fontWeight: 600,
                                  color: conditionStyle ? conditionStyle.color : "text.secondary",
                                  bgcolor: conditionStyle ? conditionStyle.bgcolor : "action.selected",
                                }}
                              />
                            </Box>
                            <IconButton size="small" onClick={(e) => handleOpenPostMenu(e, car, "cars")} aria-label="more options" sx={{ mr: -1 }}>
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          </Stack>
                          <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 1, lineHeight: 1.4, height: "2.8em", overflowWrap: "anywhere", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                            {car.title}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: 14,
                              color: "text.secondary",
                              mb: 1.5,
                              lineHeight: 1.5,
                              height: "4.5em",
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                            }}
                          >
                            {car.description}
                          </Typography>

                          <Typography sx={{ fontSize: 20, fontWeight: 700, color: "success.main", mb: 1.5 }}>
                            $ {Number(car.price).toLocaleString()}
                          </Typography>

                          <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
                            {[
                              { label: <T>Marca</T>, value: car.marca },
                              { label: <T>Modelo</T>, value: car.modelo },
                              { label: <T>Año</T>, value: car.año },
                              { label: <T>Km</T>, value: `${car.km} km` },
                              { label: <T>Ciudad</T>, value: car.city },
                            ].map((item, i) => (
                              <Grid item xs={6} key={i}>
                                <Typography sx={{ fontSize: 11, color: "text.secondary" }}>
                                  {item.label}
                                </Typography>
                                <Typography sx={{ fontSize: 14, fontWeight: 600, lineHeight: 1.5, minHeight: "1.5em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  {item.value}
                                </Typography>
                              </Grid>
                            ))}
                          </Grid>

                          <Typography sx={{ fontSize: 11, color: "text.disabled", mb: 1.5 }}>
                            <T>Publicado el</T> {formatDate(car.createdAt)}
                          </Typography>

                          {images.length > 0 ? (
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                overflowX: "auto",
                                pb: 0.5,
                                scrollbarWidth: "none",
                                "&::-webkit-scrollbar": { display: "none" },
                              }}
                            >
                              {images.map((image, index) => (
                                <CardMedia
                                  key={index}
                                  component="img"
                                  image={image}
                                  alt={`Imagen de ${car.title}`}
                                  sx={{ width: 90, height: 90, borderRadius: 2, objectFit: "cover", flexShrink: 0 }}
                                />
                              ))}
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                height: 90,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 2,
                                backgroundColor: "action.hover",
                                color: "text.disabled",
                              }}
                            >
                              <Typography sx={{ fontSize: 13 }}><T>No hay imágenes</T></Typography>
                            </Box>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                    );
                  })}
              </Grid>
            )}
            {filteredCars.length > carsLimit && <Box ref={carsSentinelRef} sx={{ height: 1 }} />}
          </TabPanel>
        )}
        {hasPlaces && (
          <TabPanel value={value} index={tabIndex("propiedades")}>
            {!loadedTabs.includes("propiedades") ? (
              tabLoadingSpinner
            ) : filteredPlaces.length === 0 ? (
              <Typography color="text.secondary" sx={{ mt: 2 }}>
                <T>No hay resultados.</T>
              </Typography>
            ) : (
              <Grid container spacing={2}>
                {filteredPlaces
                  .slice(0, placesLimit)
                  .map((place) => {
                    const images = Array.isArray(place.images)
                      ? place.images
                      : place.images
                      ? [place.images]
                      : [];
                    const categoryStyle = CATEGORY_STYLES[place.category];

                    return (
                    <Grid item key={place.id} xs={12} sm={6} md={4} lg={4}>
                      <Card
                        sx={{
                          borderRadius: 3,
                          backgroundColor: brandColors.backgroundPaper,
                          border: "1px solid",
                          borderColor: "divider",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate(`/trips/${place.id}`)}
                      >
                        <CardContent sx={{ flexGrow: 1 }}>
                          {/* Etiqueta y menú en su propia fila: al lado del título lo dejaban en una columna angosta. */}
                          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                            <Box>
                              {categoryStyle && (
                                <Chip
                                  size="small"
                                  label={categoryStyle.label}
                                  sx={{
                                    fontWeight: 600,
                                    color: categoryStyle.color,
                                    bgcolor: categoryStyle.bgcolor,
                                  }}
                                />
                              )}
                            </Box>
                            <IconButton size="small" onClick={(e) => handleOpenPostMenu(e, place, "places")} aria-label="more options" sx={{ mr: -1 }}>
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          </Stack>
                          <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 1, lineHeight: 1.4, height: "2.8em", overflowWrap: "anywhere", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                            {place.title}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: 14,
                              color: "text.secondary",
                              mb: 1.5,
                              lineHeight: 1.5,
                              height: "4.5em",
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                            }}
                          >
                            {place.description}
                          </Typography>

                          <Typography sx={{ fontSize: 20, fontWeight: 700, color: "success.main", mb: 1.5 }}>
                            $ {Number(place.price).toLocaleString()}
                          </Typography>

                          <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
                            {[
                              { label: <T>Ciudad</T>, value: place.city },
                              { label: <T>Lugar</T>, value: place.place },
                            ].map((item, i) => (
                              <Grid item xs={6} key={i}>
                                <Typography sx={{ fontSize: 11, color: "text.secondary" }}>
                                  {item.label}
                                </Typography>
                                <Typography sx={{ fontSize: 14, fontWeight: 600, lineHeight: 1.5, minHeight: "1.5em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  {item.value}
                                </Typography>
                              </Grid>
                            ))}
                          </Grid>

                          <Typography sx={{ fontSize: 11, color: "text.disabled", mb: 1.5 }}>
                            <T>Publicado el</T> {formatDate(place.createdAt)}
                          </Typography>

                          {images.length > 0 ? (
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                overflowX: "auto",
                                pb: 0.5,
                                scrollbarWidth: "none",
                                "&::-webkit-scrollbar": { display: "none" },
                              }}
                            >
                              {images.map((image, index) => (
                                <CardMedia
                                  key={index}
                                  component="img"
                                  image={image}
                                  alt={`Imagen de ${place.title}`}
                                  sx={{ width: 90, height: 90, borderRadius: 2, objectFit: "cover", flexShrink: 0 }}
                                />
                              ))}
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                height: 90,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 2,
                                backgroundColor: "action.hover",
                                color: "text.disabled",
                              }}
                            >
                              <Typography sx={{ fontSize: 13 }}><T>No hay imágenes</T></Typography>
                            </Box>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>
                    );
                  })}
              </Grid>
            )}
            {filteredPlaces.length > placesLimit && <Box ref={placesSentinelRef} sx={{ height: 1 }} />}
          </TabPanel>
        )}
      </Box>
      <Typography
        variant="caption"
        align="center"
        sx={{ display: "block", color: brandColors.textSecondary, mt: 2, mb: 10 }}
      >
        © 2026 Dapur Tecnología - Notiline
      </Typography>
      <Dialog
        open={openImageModal}
        onClose={handleCloseImageModal}
        aria-label="Galería de imágenes"
        fullScreen
        PaperProps={{ sx: { backgroundColor: "#000" } }}
      >
        {openImageModal && (
          <Box
            style={styles.imageModalContent}
            onTouchStart={handleModalTouchStart}
            onTouchEnd={handleModalTouchEnd}
          >
            <Box style={styles.imageModalTopBar}>
              {modalImages.length > 1 ? (
                <Typography style={styles.imageModalCounter}>
                  {currentImageIndex + 1} / {modalImages.length}
                </Typography>
              ) : (
                <span />
              )}
              <IconButton
                onClick={handleCloseImageModal}
                aria-label="Cerrar"
                sx={{ color: "#fff" }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {modalImages && modalImages.length > 0 ? (
              <CardMedia
                component="img"
                image={modalImages[currentImageIndex]}
                alt={`Imagen ${currentImageIndex + 1} de ${modalImages.length}`}
                style={styles.imageModalImage}
              />
            ) : (
              <Typography sx={{ color: "#fff" }}><T>No hay imágenes disponibles</T></Typography>
            )}

            {modalImages.length > 1 && (
              <>
                <IconButton
                  onClick={handlePreviousImage}
                  style={{ ...styles.imageModalNavButton, left: 8 }}
                  aria-label="Imagen anterior"
                >
                  <ArrowBackIosIcon sx={{ color: "#fff" }} />
                </IconButton>
                <IconButton
                  onClick={handleNextImage}
                  style={{ ...styles.imageModalNavButton, right: 8 }}
                  aria-label="Imagen siguiente"
                >
                  <ArrowForwardIosIcon sx={{ color: "#fff" }} />
                </IconButton>
                <Box style={styles.imageModalDots}>
                  {modalImages.map((_, i) => (
                    <Box
                      key={i}
                      onClick={() => setCurrentImageIndex(i)}
                      style={{
                        ...styles.imageModalDot,
                        ...(i === currentImageIndex ? styles.imageModalDotActive : {}),
                      }}
                    />
                  ))}
                </Box>
              </>
            )}
          </Box>
        )}
      </Dialog>
      <Dialog open={!!deleteTarget} onClose={cancelDelete}>
        <DialogTitle><T>Eliminar publicación</T></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <T>¿Seguro que querés eliminar esta publicación? Esta acción no se puede deshacer.</T>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete}><T>Cancelar</T></Button>
          <Button color="error" onClick={confirmDelete}><T>Eliminar</T></Button>
        </DialogActions>
      </Dialog>

      {/* Un solo menú ⋮ para todas las secciones del perfil (ofertas, eventos,
          hilos, autos y propiedades): mismas opciones en el mismo orden. */}
      <Menu anchorEl={postMenu?.anchorEl} open={Boolean(postMenu)} onClose={handlePostMenuClose}>
        {postMenu && (() => {
          const { item, kind } = postMenu;
          const authorUid = postAuthorUid(postMenu);
          const isMine = !!myUid && item.uid === myUid;
          const isMyContent = !!myUid && authorUid === myUid;
          const canEdit = isMine && !(kind === "threads" && item.repostOf);
          const run = (action) => () => {
            handlePostMenuClose();
            action();
          };
          return [
            <MenuItem key="view" onClick={run(() => navigate(postPath(postMenu)))}>
              <T>Ver publicación</T>
            </MenuItem>,
            <MenuItem key="share" onClick={run(() => handleSharePost(postMenu))}>
              <T>Compartir</T>
            </MenuItem>,
            <MenuItem key="copy" onClick={run(() => handleCopyPostLink(postMenu))}>
              <T>Copiar enlace</T>
            </MenuItem>,
            canEdit && (
              <MenuItem key="edit" onClick={run(() => handleEditPost(postMenu))}>
                <T>Editar publicación</T>
              </MenuItem>
            ),
            isMine && (
              <MenuItem key="delete" onClick={run(() => requestDelete(kind, item.id))} sx={{ color: "#ff6b6b" }}>
                <T>Eliminar publicación</T>
              </MenuItem>
            ),
            myUid && !isMyContent && isCompanyFollowed(authorUid) && (
              <MenuItem key="unfollow" onClick={run(() => unfollowCompany(authorUid, myUid, setFollowing))}>
                <T>Dejar de seguir</T>
              </MenuItem>
            ),
            myUid && !isMyContent && (
              <MenuItem key="report" onClick={run(() => handleReportPost(postMenu))}>
                <T>Reportar</T>
              </MenuItem>
            ),
            myUid && !isMyContent && (
              <MenuItem key="block" onClick={run(() => handleToggleBlockPostAuthor(postMenu))}>
                {blockedIds.includes(authorUid) ? <T>Desbloquear</T> : <T>Bloquear</T>}
              </MenuItem>
            ),
          ].filter(Boolean);
        })()}
      </Menu>

      {/* Los hilos del perfil se cargan una vez (useTabFetch): se actualiza la lista a mano. */}
      <EditThreadDialog
        thread={editingThread}
        onClose={() => setEditingThread(null)}
        onSaved={(changes) =>
          setProfileThreads((prev) => prev.map((t) => (t.id === editingThread.id ? { ...t, ...changes } : t)))
        }
      />

      <Dialog open={openAttendeesDialog} onClose={handleCloseAttendeesDialog} fullWidth maxWidth="xs">
        <DialogTitle><T>Asistentes</T></DialogTitle>
        <DialogContent>
          {isLoadingAttendees ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <List>
              {(attendees[selectedEventId] || []).map((attendeeId) => (
                <ListItem
                  key={attendeeId}
                  button
                  onClick={() => handleAttendeeClick(attendeeId)}
                  sx={{ cursor: "pointer" }}
                >
                  <Avatar
                    src={attendeeUserProfiles[attendeeId]?.profileImageUrl || ""}
                    alt={attendeeUserProfiles[attendeeId]?.name || "Usuario"}
                    sx={{ width: 32, height: 32, mr: 2 }}
                  />
                  <Typography>{attendeeUserProfiles[attendeeId]?.name || "Usuario"}</Typography>
                </ListItem>
              ))}
              {(attendees[selectedEventId] || []).length === 0 && (
                <Typography color="text.secondary" sx={{ p: 2 }}>
                  <T>Todavía no hay asistentes.</T>
                </Typography>
              )}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAttendeesDialog}><T>Cerrar</T></Button>
        </DialogActions>
      </Dialog>

      <BottomToolbar />
      <FollowListDialog
        open={!!followListTab}
        onClose={() => setFollowListTab(null)}
        uid={profileUid}
        initialTab={followListTab || "following"}
        onFollowChange={handleFollowListChange}
      />
      <MessagesClosedDialog open={messagesClosedOpen} onClose={() => setMessagesClosedOpen(false)} name={profile?.displayName} />
    </Container>
  );
};

export default ProfilePage;
